var _defs, _g, _path, _g2, _text, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _circle2, _circle3, _path13, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAraclar09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437.62 270.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-11,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-13,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-168,.cls-169,.cls-17,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-19,.cls-2,.cls-21,.cls-23,.cls-24,.cls-25,.cls-26,.cls-28,.cls-30,.cls-31,.cls-32,.cls-33,.cls-35,.cls-38,.cls-39,.cls-4,.cls-41,.cls-43,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-8,.cls-80,.cls-81,.cls-82,.cls-84,.cls-86,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill-rule:evenodd;}.cls-11,.cls-13,.cls-15,.cls-17,.cls-19,.cls-2,.cls-21,.cls-4,.cls-6,.cls-8,.cls-9{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{mask:url(#mask-6);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{mask:url(#mask-7);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{mask:url(#mask-8);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{mask:url(#mask-9);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{mask:url(#mask-10);filter:url(#luminosity-noclip-12);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{mask:url(#mask-11);}.cls-21{fill:url(#linear-gradient-11);}.cls-22,.cls-23,.cls-31{fill:#010101;}.cls-24{fill:#3d9cd6;}.cls-25{fill:#1f1e20;}.cls-26,.cls-36{fill:#3f4045;}.cls-27{mask:url(#mask-12);}.cls-28{fill:url(#linear-gradient-12);}.cls-29{mask:url(#mask-13);}.cls-30{fill:url(#linear-gradient-13);}.cls-31,.cls-32,.cls-37,.cls-44,.cls-81{opacity:0.5;}.cls-183,.cls-32,.cls-37,.cls-45,.cls-57{fill:#fff;}.cls-33{fill:#485154;}.cls-34{mask:url(#mask-14);}.cls-35{fill:url(#linear-gradient-14);}.cls-38{fill:url(#New_Gradient_19);}.cls-39{fill:url(#linear-gradient-15);}.cls-40{mask:url(#mask-15);}.cls-41{fill:url(#linear-gradient-16);}.cls-42{mask:url(#mask-16);}.cls-43{fill:url(#linear-gradient-17);}.cls-46{fill:url(#New_Gradient_16);}.cls-47{fill:#dbe2e9;}.cls-48{fill:#9a1b1f;}.cls-49{fill:#553e46;}.cls-50{fill:#8d3d3c;}.cls-51{fill:url(#New_Gradient_8);}.cls-52{fill:#938484;}.cls-53{fill:#e9ecf0;}.cls-54{fill:#704147;}.cls-55{fill:#d9332a;}.cls-56{fill:#db2927;}.cls-58{fill:#c62d27;}.cls-59{fill:#ac999a;}.cls-60{fill:#5b565d;}.cls-61{mask:url(#mask-17);}.cls-62{fill:url(#linear-gradient-18);}.cls-63{fill:url(#linear-gradient-19);}.cls-64{fill:url(#New_Gradient_16-2);}.cls-65{fill:#b4b4b4;}.cls-66{fill:#3d3d3e;}.cls-67{fill:#7992a7;}.cls-68{fill:#4e4c4d;}.cls-69{fill:#3a3a39;}.cls-70{fill:url(#New_Gradient_16-3);}.cls-71{fill:url(#New_Gradient_9);}.cls-72{fill:#535f6e;}.cls-73{fill:url(#New_Gradient_4);}.cls-74{fill:#b6b4b5;}.cls-75{fill:url(#New_Gradient_24);}.cls-76{fill:url(#New_Gradient_23);}.cls-77{fill:url(#New_Gradient_38);}.cls-78{fill:#222;}.cls-79{mask:url(#mask-18);}.cls-80{fill:url(#linear-gradient-20);}.cls-81{fill:#708a82;}.cls-82{fill:#535258;}.cls-83{mask:url(#mask-19);}.cls-84{fill:url(#linear-gradient-21);}.cls-85{mask:url(#mask-20);}.cls-86{fill:url(#linear-gradient-22);}.cls-87{mask:url(#mask-21);}.cls-88{fill:url(#linear-gradient-23);}.cls-89{fill:url(#New_Gradient_21);}.cls-90{fill:url(#New_Gradient_59);}.cls-91{fill:url(#New_Gradient_45);}.cls-92{fill:url(#New_Gradient_21-2);}.cls-93{fill:url(#New_Gradient_45-2);}.cls-94{fill:#b7b6b2;}.cls-95{fill:#83868a;}.cls-96{fill:url(#New_Gradient_44);}.cls-97{fill:url(#linear-gradient-24);}.cls-98{fill:#b2b2b2;}.cls-99{fill:#b0afab;}.cls-100{fill:#333230;}.cls-101{fill:#888384;}.cls-102{fill:#56555a;}.cls-103{fill:#d5d3d3;}.cls-104{fill:#a4a3a1;}.cls-105{fill:#e0dedf;}.cls-106{fill:url(#New_Gradient_35);}.cls-107{fill:#71706e;}.cls-108{fill:#464445;}.cls-109{fill:#bfbcbd;}.cls-110{fill:#888884;}.cls-111{fill:#ebebe9;}.cls-112{fill:#6f6e6b;}.cls-113{fill:#4a4645;}.cls-114{fill:#84837f;}.cls-115{fill:#989792;}.cls-116{fill:#8c8b89;}.cls-117{mask:url(#mask-22);}.cls-118{fill:url(#linear-gradient-25);}.cls-119{fill:url(#New_Gradient_21-3);}.cls-120{fill:#575654;}.cls-121{fill:#5c5c57;}.cls-122{fill:#949192;}.cls-123{fill:#663714;}.cls-124{fill:#935222;}.cls-125{fill:#56301f;}.cls-126{fill:#74401a;}.cls-127{fill:#d99028;}.cls-128{fill:#8f4d21;}.cls-129{fill:url(#linear-gradient-26);}.cls-130{fill:url(#New_Gradient_19-2);}.cls-131{fill:url(#linear-gradient-27);}.cls-132{fill:#383739;}.cls-133{fill:url(#linear-gradient-28);}.cls-134{fill:url(#New_Gradient_85);}.cls-135{fill:#3b3737;}.cls-136{fill:url(#linear-gradient-29);}.cls-137{fill:#7f8080;}.cls-138{fill:#ebebeb;}.cls-139{fill:#c8c8c8;}.cls-140{fill:#818182;}.cls-141{fill:#737476;}.cls-142{fill:#999798;}.cls-143{fill:#444445;}.cls-144{fill:#e5e5e5;}.cls-145{fill:#0f1013;}.cls-146{fill:#c8c7c6;}.cls-147{fill:#cfcbca;}.cls-148{fill:#170f0c;}.cls-149{fill:#f3f0f2;}.cls-150{fill:#bfbebe;}.cls-151{fill:#545d62;}.cls-152{fill:#474c53;}.cls-153{fill:#1f1f1c;}.cls-154{fill:#615e5d;}.cls-155{fill:#abaaaa;}.cls-156{fill:#737170;}.cls-157{fill:url(#New_Gradient_92);}.cls-158{fill:#343d46;}.cls-159{fill:url(#New_Gradient_92-2);}.cls-160{fill:#acb5c0;}.cls-161{fill:#1a1b1c;}.cls-162{fill:url(#linear-gradient-30);}.cls-163{fill:url(#New_Gradient_85-2);}.cls-164{fill:url(#linear-gradient-31);}.cls-165{fill:#b5b6b6;}.cls-166{fill:#171518;}.cls-167{fill:#58585a;}.cls-168{fill:url(#New_Gradient_21-4);}.cls-169{fill:url(#New_Gradient_59-2);}.cls-170{fill:url(#New_Gradient_45-3);}.cls-171{fill:url(#New_Gradient_21-5);}.cls-172{fill:url(#New_Gradient_45-4);}.cls-173{fill:url(#New_Gradient_44-2);}.cls-174{fill:#d2d3d4;}.cls-175{fill:#a8aaad;}.cls-176{fill:#6e6f72;}.cls-177{font-size:13.63px;letter-spacing:-0.14em;}.cls-177,.cls-183{font-family:Biko-Bold, Biko;font-weight:700;}.cls-178{letter-spacing:-0.06em;}.cls-179{letter-spacing:-0.1em;}.cls-180{letter-spacing:-0.08em;}.cls-181{fill:none;}.cls-182{fill:#231f20;}.cls-183{font-size:13.85px;letter-spacing:-0.08em;}.cls-184{filter:url(#luminosity-noclip-11);}.cls-185{filter:url(#luminosity-noclip-10);}.cls-186{filter:url(#luminosity-noclip-9);}.cls-187{filter:url(#luminosity-noclip-8);}.cls-188{filter:url(#luminosity-noclip-7);}.cls-189{filter:url(#luminosity-noclip-6);}.cls-190{filter:url(#luminosity-noclip-4);}.cls-191{filter:url(#luminosity-noclip-3);}.cls-192{filter:url(#luminosity-noclip-2);}.cls-193{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 26.91,
    y: -10600.78,
    width: 242.25,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 26.91,
    y: -10600.78,
    width: 242.25,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2082.91,
    y1: 118.99,
    x2: 2082.91,
    y2: 80.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 360.21,
    y: -10600.78,
    width: 47.11,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 360.21,
    y: -10600.78,
    width: 47.11,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1847.42,
    y1: 135.05,
    x2: 1846.3,
    y2: 131.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 263.97,
    y: -10600.78,
    width: 68.83,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 263.97,
    y: -10600.78,
    width: 68.83,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1955.76,
    y1: 142.39,
    x2: 1928.07,
    y2: 106.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 302.29,
    y: -10600.78,
    width: 113.29,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 302.29,
    y: -10600.78,
    width: 113.29,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1873.24,
    y1: 146.09,
    x2: 1871.66,
    y2: 173.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1872.96,
    y1: 145.8,
    x2: 1871.97,
    y2: 167.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 359.43,
    y: -10600.78,
    width: 53.02,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 359.43,
    y: -10600.78,
    width: 53.02,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1822.56,
    y1: 142.7,
    x2: 1869.68,
    y2: 142.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0bfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 29.94,
    y: -10600.78,
    width: 283.64,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 29.94,
    y: -10600.78,
    width: 283.64,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2059.19,
    y1: 73.21,
    x2: 2059.19,
    y2: 87.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 267.92,
    y: -10600.78,
    width: 62.14,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 267.92,
    y: -10600.78,
    width: 62.14,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1933.29,
    y1: 109.3,
    x2: 1931.51,
    y2: 95.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 261.45,
    y: -10600.78,
    width: 64.55,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 261.45,
    y: -10600.78,
    width: 64.55,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1937.22,
    y1: 184.46,
    x2: 1937.22,
    y2: 167.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 61.98,
    y: -10600.78,
    width: 83.85,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 61.98,
    y: -10600.78,
    width: 83.85,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2127.04,
    y1: 114.58,
    x2: 2127.04,
    y2: 165.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 67.59,
    y: -10600.78,
    width: 63.27,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 67.59,
    y: -10600.78,
    width: 63.27,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2131.73,
    y1: 167.25,
    x2: 2131.73,
    y2: 151.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 26.91,
    y: 71.19,
    width: 242.25,
    height: 30.58,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.79,86.17l1.38,14.73c-5.9-.63-11.54-1.05-16.54-1.21-1.23,0,.67-3.32-.48-3.33s-.17,3-6.67,3.3c-18.4.79-24.93.28-38.25,1.41s-44.19-.28-64-.28-43.06.28-58.07.85-40.71-1-43.35-1.13c-.71,0-3.8,0-5.51-4.4-.38-1,.39,3.76-.82,3.4a18.16,18.16,0,0,1-8.55-5.28c.13-5.78.23-11.54.3-17.24a6.05,6.05,0,0,1,6-5.8H35.6v1.93a1,1,0,0,0,1,1h1.55a1,1,0,0,0,1-1V73h3.57a1.49,1.49,0,0,0,1.48-1.48v-.34h165v.34A1.49,1.49,0,0,0,210.7,73h3.57v.11a1,1,0,0,0,1,1h1.54a1,1,0,0,0,1-1V73h3.57a1.48,1.48,0,0,0,1.48-1.48v-.34h23.53v.34A1.49,1.49,0,0,0,248,73h3.57v.11a1,1,0,0,0,1,1h1.54a1,1,0,0,0,1-1V71.19h6.55c4.12,0-3.3,11.53,6.1,15Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2082.91,
    y1: 118.99,
    x2: 2082.91,
    y2: 80.46,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 29.94,
    y: 73.79,
    width: 283.64,
    height: 23.39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M29.94,96.15,30.16,77a4.9,4.9,0,0,1,.66-2.36c.71-.46,1.15-.72,1.15-.72s242.25-.27,249.69,0,13.43.38,20.94,2.39,11,6.47,11,6.47S303,96.59,271.5,97s-237.23-.23-241.56-.89Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2059.19,
    y1: 73.21,
    x2: 2059.19,
    y2: 87.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 261.45,
    y: 167.15,
    width: 64.55,
    height: 9.09,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M326,174.78c-.54.46-1.06.95-1.56,1.46l-54.52-.05v-2.08h0a4.87,4.87,0,0,0-2.14-4.52c-1.38-.9-3.45-1.34-6.33-1.24v-1.2h44.07L326,174.78Zm-64.55-5.66c2.73-.1,4.66.3,5.9,1.11s1.66,2.16,1.62,3.87h0v2.07h-7.51v-7.06Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1937.22,
    y1: 184.46,
    x2: 1937.22,
    y2: 167.61,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_19",
    x1: 1528.93,
    y1: 685.07,
    x2: 1587.04,
    y2: 719.99,
    gradientTransform: "matrix(-0.99, 0, 0, 1, 1641.22, -507.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3d3d3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#3d3d3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 79.61,
    y1: 171.75,
    x2: 99.37,
    y2: 185.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 61.98,
    y: 149.48,
    width: 83.85,
    height: 16.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 61.98,
    y: 149.48,
    width: 83.85,
    height: 16.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M144.46,164.39l1.38-.43-5.1-5.33s-4.41-7.25-21.11-8.51-35.18-.31-43,0-10,2-11.55,6.09S62,165.56,62,165.56l.46.3C63,164,64,160.79,65,158.08,66.6,154,68.7,152.31,76.58,152s26.35-1.26,43.05,0,21.11,8.51,21.11,8.51l3.72,3.89Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2127.04,
    y1: 114.58,
    x2: 2127.04,
    y2: 165.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 67.59,
    y: 152.09,
    width: 63.27,
    height: 9.88,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M100.77,152.09h-3.1c-5.31,0-16,.27-20.8,1.47-6.44,1.63-14.51,3.59-4.73,5.71a137.65,137.65,0,0,0,54.16,0c9.79-2.12,1.71-4.08-4.73-5.71-4.75-1.2-15.49-1.43-20.8-1.47Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2131.73,
    y1: 167.25,
    x2: 2131.73,
    y2: 151.56,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_16",
    x1: 1430.78,
    y1: 753.01,
    x2: 1420.01,
    y2: 753.01,
    gradientTransform: "matrix(-1, 0, 0, 1, 1455.74, -563.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#535f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#232630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_8",
    x1: 1893.92,
    y1: -903.46,
    x2: 1879.15,
    y2: -967.43,
    gradientTransform: "matrix(-0.63, 0.1, -0.01, 0.57, 1218.28, 504.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b3c0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#89a0ae"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 360.21,
    y: 126.62,
    width: 47.11,
    height: 14.82,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M360.21,127l10.46-.36c16.94,4.31,29.13,8.27,36.65,14.82-1.53-.55-3.67-1.33-6.65-2.44-10.35-3.87-32.52-9.9-40.46-12Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1847.42,
    y1: 135.05,
    x2: 1846.3,
    y2: 131.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1608.03,
    y1: 804.96,
    x2: 1757.47,
    y2: 804.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 2023.83, -679.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#99918f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_16-2",
    x1: 1193.86,
    y1: 583.24,
    x2: 1248.62,
    y2: 583.24,
    gradientTransform: "matrix(-1, 0, 0, 1, 1615.75, -396.24)",
    xlinkHref: "#New_Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_16-3",
    x1: 2187.47,
    y1: -921.95,
    x2: 2208.24,
    y2: -921.95,
    gradientTransform: "matrix(-0.71, 0, 0, 0.56, 1964.63, 700.47)",
    xlinkHref: "#New_Gradient_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_9",
    x1: 2177.54,
    y1: -934.7,
    x2: 2177.54,
    y2: -941.96,
    gradientTransform: "matrix(-0.71, 0, 0, 0.56, 1949.79, 709.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#535f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_4",
    x1: 2202.99,
    y1: -930.75,
    x2: 2186.31,
    y2: -930.75,
    gradientTransform: "matrix(-0.71, 0, 0, 0.56, 1964.63, 700.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a69ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_24",
    x1: 1200.3,
    y1: 574.04,
    x2: 1194.31,
    y2: 574.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 1615.75, -396.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7992a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_23",
    x1: 1719.79,
    y1: 724.47,
    x2: 1671.46,
    y2: 724.47,
    gradientTransform: "matrix(-1, 0, 0, 1, 2084.56, -548.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7b7678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_38",
    x1: 1673.32,
    y1: 724.1,
    x2: 1719.79,
    y2: 724.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 2084.56, -548.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8a8385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 263.97,
    y: 82.12,
    width: 68.83,
    height: 57.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.3,82.3l-.43-.18s-6.22.5-5.88,5S266.76,112,266.76,112s-1.34,13.42,23,18.94,41.05,8.52,41.05,8.52l2,.2,0-1.66s-16.72-3-41.05-8.52-23-18.93-23-18.93-2-18.79-2.35-23.32c-.24-3.19,2.37-4.47,3.92-4.94Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1955.76,
    y1: 142.39,
    x2: 1928.07,
    y2: 106.8,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 302.29,
    y: 151.97,
    width: 113.29,
    height: 17.09,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.59,169.06s-7.8-6.51-24.86-10.06-48-7-58-7-16.87-.49-21.9,2.66a19.32,19.32,0,0,0-8.54,10.64l3.43.09,2.68,1.13c1.31-3,5-7.17,15.25-7.91,16.48-1.18,39-.49,54.55,1.87s25.05,3.65,37.39,8.58Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1873.24,
    y1: 146.09,
    x2: 1871.66,
    y2: 173.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 302.29,
    y: 150.57,
    width: 113.29,
    height: 18.18,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M415.59,168.74s-7.8-6.6-24.86-10.35-48-7.58-58-7.7-16.87-.7-21.9,2.4a18.94,18.94,0,0,0-8.54,10.53l.63,0a19.26,19.26,0,0,1,7.91-8.95c5-3.14,11.93-2.62,21.9-2.58s40.93,3.59,58,7.2c11.63,2.47,19,6.29,22.44,8.47l2.42,1Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1872.96,
    y1: 145.8,
    x2: 1871.97,
    y2: 167.05,
    gradientTransform: "matrix(-1, 0, 0, 1, 2230.95, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 359.43,
    y: 128.94,
    width: 53.02,
    height: 27.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M412.45,156.47s-3.36-7.24-4.89-9.7a13.06,13.06,0,0,0-7.13-5.35c-3.09-1-40.8-12.48-40.8-12.48s-.56-.2.18,2.59a5.64,5.64,0,0,0,2.7,3.71l37.83,10.11s6.48,1.07,12.11,11.12Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1822.56,
    y1: 142.7,
    x2: 1869.68,
    y2: 142.7,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_21",
    x1: -986.39,
    y1: -906.97,
    x2: -986.39,
    y2: -877.47,
    gradientTransform: "translate(815.65 643.67) scale(0.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2b2a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_59",
    x1: -992.15,
    y1: -913.68,
    x2: -992.15,
    y2: -924.01,
    gradientTransform: "translate(816.48 658.2) scale(0.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c6c5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_45",
    x1: -990.71,
    y1: -892.51,
    x2: -990.71,
    y2: -911,
    gradientTransform: "translate(815.11 648.6) scale(0.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#c6c5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2b2a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_21-2",
    x1: -994.62,
    y1: -908.84,
    x2: -994.62,
    y2: -886.81,
    gradientTransform: "translate(820.15 645.96) scale(0.56)",
    xlinkHref: "#New_Gradient_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_45-2",
    x1: -3028.84,
    y1: 4517.64,
    x2: -3044.26,
    y2: 4517.64,
    gradientTransform: "translate(2777.79 1832.56) rotate(90) scale(0.56)",
    xlinkHref: "#New_Gradient_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_44",
    x1: -979.16,
    y1: -885.29,
    x2: -979.16,
    y2: -906.28,
    gradientTransform: "translate(815.2 644.73) scale(0.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#c6c5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2b2a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1790.38,
    y1: 749.79,
    x2: 1759.66,
    y2: 715.67,
    gradientTransform: "matrix(-1, 0, 0, 1, 2155.61, -582.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_35",
    x1: 2547.59,
    y1: -810.45,
    x2: 2563.22,
    y2: -808.25,
    gradientTransform: "matrix(-0.57, 0, 0, 0.57, 1861.13, 617.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c6c3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 267.92,
    y: 85.86,
    width: 62.14,
    height: 26.43,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.06,112.3v-.57c0-1.16-1.31-3.08-2.11-3.92L311.8,90.72c-1.75-1.85-3.92.33-3.78,1.48l1.89,15.58c7.73,1.52,14.42,3,20.15,4.52ZM305.93,107l-2-20.14-36.05-1,1.45,15.58c14.07,1.72,26.19,3.63,36.56,5.57Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1933.29,
    y1: 109.3,
    x2: 1931.51,
    y2: 95.66,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_21-3",
    x1: 2198.23,
    y1: -900.23,
    x2: 2198.23,
    y2: -853.98,
    gradientTransform: "matrix(-0.66, 0, 0, 0.55, 1787.26, 606.98)",
    xlinkHref: "#New_Gradient_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2203.36,
    y1: -921.43,
    x2: 2209.84,
    y2: -922.23,
    gradientTransform: "matrix(-0.66, 0, 0, 0.55, 1792.11, 628.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a7ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2b2a2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_19-2",
    x1: 1259.2,
    y1: 566.12,
    x2: 1291.27,
    y2: 589.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 1615.75, -396.24)",
    xlinkHref: "#New_Gradient_19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 315.47,
    y1: 188.19,
    x2: 374.09,
    y2: 188.19,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 560.6,
    y1: 225.79,
    x2: 527.87,
    y2: 168.21,
    gradientTransform: "translate(-452.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#474c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8b0ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_85",
    x1: 164.04,
    y1: 1773.31,
    x2: 176.57,
    y2: 1794.15,
    gradientTransform: "translate(-187.12 -2754.7) scale(1.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#474c47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 176.48,
    y1: 1794.87,
    x2: 164.13,
    y2: 1772.58,
    gradientTransform: "translate(-187.12 -2754.7) scale(1.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#474c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8b0ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_92",
    x1: -561.06,
    y1: -897.03,
    x2: -556.83,
    y2: -900.46,
    gradientTransform: "translate(413.02 714.04) scale(0.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#474c53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#aeb8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#474c53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_92-2",
    x1: -1365.35,
    y1: -3290.78,
    x2: -1361.7,
    y2: -3293.74,
    gradientTransform: "translate(567.87 1344.62) scale(0.35)",
    xlinkHref: "#New_Gradient_92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1.06,
    y1: 1795.9,
    x2: -13.75,
    y2: 1769.18,
    gradientTransform: "translate(360.98 -2754.7) scale(1.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#474c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8b0ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_85-2",
    x1: -12.6,
    y1: 1772.12,
    x2: -0.08,
    y2: 1792.96,
    gradientTransform: "translate(360.98 -2754.7) scale(1.66)",
    xlinkHref: "#New_Gradient_85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -0.16,
    y1: 1793.69,
    x2: -12.52,
    y2: 1771.39,
    gradientTransform: "translate(360.98 -2754.7) scale(1.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#474c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8b0ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_21-4",
    x1: -225.49,
    y1: 459.55,
    x2: -225.49,
    y2: 443.17,
    gradientTransform: "translate(478.45 -303.02)",
    xlinkHref: "#New_Gradient_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_59-2",
    x1: -228.77,
    y1: 438.25,
    x2: -228.77,
    y2: 443.99,
    gradientTransform: "translate(479.37 -293.04)",
    xlinkHref: "#New_Gradient_59"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_45-3",
    x1: -228.64,
    y1: 440.93,
    x2: -228.64,
    y2: 451.2,
    gradientTransform: "translate(478.66 -298.08)",
    xlinkHref: "#New_Gradient_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_21-5",
    x1: -230.81,
    y1: 454.37,
    x2: -230.81,
    y2: 442.12,
    gradientTransform: "translate(483.71 -300.72)",
    xlinkHref: "#New_Gradient_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_45-4",
    x1: -230.64,
    y1: 433.97,
    x2: -230.64,
    y2: 442.53,
    gradientTransform: "translate(484.14 -292.19)",
    xlinkHref: "#New_Gradient_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_44-2",
    x1: -232.35,
    y1: 441.93,
    x2: -232.35,
    y2: 453.59,
    gradientTransform: "translate(488.88 -300.34)",
    xlinkHref: "#New_Gradient_44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basis"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 416.66,
    y: 193.8,
    width: 6.21,
    height: 8.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M23.63,72.9l5.75-.5a1,1,0,0,1,1,1v5.2a1,1,0,0,1-1,1L23.63,79a1.05,1.05,0,0,1-1-1v0l-3.21-.32a.6.6,0,0,1-.59-.55V74.85a.58.58,0,0,1,.59-.55L22.63,74v-.12a1,1,0,0,1,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M20.83,155.08c0-4.64.44-8,2.94-8a2.64,2.64,0,0,1,1.13.27v16.25a2.63,2.63,0,0,1-1.13.26c-2.5,0-2.94-4.18-2.94-8.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "292.6 193.37 384.38 192.65 383.16 169.13 293.73 169.73 292.6 193.37 292.6 193.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M407.83,185.86l-348.07.78.39,12.1H116.8L140,202.13h19.57v2.13h3.89l.19,2.53c.2,2.52,3.7,1.74,3.7,1.74h19.82l-.2,6.22H224.5l3.3-3.69,5.64.39,2.91-3.11,3.3,1.36s37.32-.58,42.17,0,5.52-3.3,8.94-3.3,4.49-2.37,5.63-4.27l11-3.5,28.54-3.38h12.44V206h34.47l4.44-5v-5.67h20.57v-9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M334.43,117.38l3.69,21.91-28.48-7.13A8.9,8.9,0,0,1,310,131L310,131a1.28,1.28,0,0,1,0-1.79l2.8-2.73A27.06,27.06,0,0,1,315,123.9a8.1,8.1,0,0,1,1.68-1.3l8.91-8.7a1.27,1.27,0,0,1,1.79,0l.29.3a1.26,1.26,0,0,1,0,1.79l-6,5.85a9.73,9.73,0,0,1,3.29,1.31,23.33,23.33,0,0,1,2.57-4.62c1.95-2.87,6.88-1.18,6.88-1.18ZM263.28,99c1.87,6.28,5.32,10.8,7.69,10.09s2.79-6.37.92-12.66-5.32-10.8-7.7-10.09-2.78,6.37-.91,12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M33.57,71.88a6.07,6.07,0,0,0-4.16,1.7,5.58,5.58,0,0,0-1.77,3.92c-.1,8.84-.3,17.66-.49,26.45s-.4,17.71-.5,26.18a36.12,36.12,0,0,1-1.2,7.08,35.91,35.91,0,0,0-1.18,6.95c0,3.81-.09,7.48-.15,10.89-.22,12.78-.37,21.85,1.25,23.13a1.35,1.35,0,0,1,.17.17,1.84,1.84,0,0,1,.43,1l-.44-.51.44.51c0,.48,0,1.27-.08,2.31-.09,2.42-.23,6.17-.23,9.92,0,5.62.25,11.21,1.31,11.21H258.2l.08-26.76c0-.13,0-.22.11-.22h0l66.06.16h0l.32.69-.32-.69,3,.07a19.79,19.79,0,0,1,9.42-5.18,46.18,46.18,0,0,1,12.83-1.22,53.43,53.43,0,0,1,12.47,1.46,22.94,22.94,0,0,1,9.76,5.28l47.64.51,0-4.28v0l.43.51-.43-.51a1.12,1.12,0,0,0-.49-.92,7.39,7.39,0,0,0-2.95-1.16.46.46,0,0,1-.21-.12,2,2,0,0,1-.53-1l-1.57-9c0-.19,0-.31.1-.31h0l.66,0c.62,0,1.05,0,1.21-.06-.82-9.38-4.81-15.57-12-20.29-7.54-5-18.5-8.37-32.91-12l-16.39.57c-.09,0-.25-.1-.42-.32l.08-.37-.08.37a267.26,267.26,0,0,0-18.86-22.66c-6.81-7.39-14.06-14.65-21.49-21.85a1.93,1.93,0,0,1-.36-.48c-.2-.38-.25-.73-.11-.78h0l3.7-1.41c-2-3.28-6.78-5.41-15.1-6.8-9-1.51-22-2-39.81-2h-6.43v1.75a1.28,1.28,0,0,1-.35.89,1.17,1.17,0,0,1-.81.33h-1.54a1.47,1.47,0,0,1-1-.46,2.84,2.84,0,0,1-.52-.69h-3.1a1.89,1.89,0,0,1-1.3-.59,3.32,3.32,0,0,1-.79-1.23h-22.8V72a1.65,1.65,0,0,1-.48,1.19,1.55,1.55,0,0,1-1.12.47h-3.45a1.28,1.28,0,0,1-.35.82,1.17,1.17,0,0,1-.81.33h-1.54a1.45,1.45,0,0,1-1-.46,2.84,2.84,0,0,1-.52-.69H211a1.91,1.91,0,0,1-1.3-.59,3.45,3.45,0,0,1-.79-1.23H44.7V72a1.65,1.65,0,0,1-.48,1.19,1.55,1.55,0,0,1-1.11.47H39.65a1.23,1.23,0,0,1-.35.82,1.14,1.14,0,0,1-.8.33H37a1.43,1.43,0,0,1-1-.46,2.56,2.56,0,0,1-.81-1.78v-.73Zm2-.69-.33-.69c.16,0,.44.31.62.69a1.19,1.19,0,0,1,.14.53v1.71a.82.82,0,0,0,.28,0h1.55a.91.91,0,0,0,.66-.28.82.82,0,0,0,.26-.58V72.5h0c0-.14,0-.2.14-.18h3.54a1.39,1.39,0,0,0,1-.41,1.28,1.28,0,0,0,.39-.89v-.34h0c0-.13.06-.19.14-.18H208.9l.32.69-.32-.69c.16,0,.44.31.62.69a1.34,1.34,0,0,1,.14.53V72s-.11-.05-.07,0a1.07,1.07,0,0,0,.79.29H214l.32.69-.32-.69c.16,0,.44.31.62.69a1.41,1.41,0,0,1,.13.42.85.85,0,0,0,.29,0h1.54a.91.91,0,0,0,.67-.28.82.82,0,0,0,.26-.58V72.5h0c0-.14,0-.2.14-.18h3.54a1.39,1.39,0,0,0,1-.41,1.28,1.28,0,0,0,.39-.89v-.34h0c0-.13.05-.19.14-.18h23.5l.32.69-.32-.69c.16,0,.44.31.62.69a1.54,1.54,0,0,1,.14.53V72s-.12-.05-.07,0a1.07,1.07,0,0,0,.79.29h3.57l.32.69-.32-.69c.16,0,.44.31.61.69a1.47,1.47,0,0,1,.14.42.85.85,0,0,0,.29,0h1.54a.91.91,0,0,0,.67-.28.81.81,0,0,0,.25-.58V70.68h0c0-.13.06-.19.14-.18h6.53c17.81,0,30.82.5,39.85,2,9.22,1.54,14.46,4.27,16.59,8.74l-.28,0,.28,0c.18.38.2.69.06.71l-3.34,1.28c7.11,6.9,14,13.87,20.58,21A273.07,273.07,0,0,1,354,126.79l16.26-.56h.06c14.46,3.68,25.47,7.11,33.11,12.13,7.81,5.14,12.2,11.87,13.19,22a.64.64,0,0,1,0,.82c-.08.11-.58.13-1.42.16h-.5l1.35,7.82a7.31,7.31,0,0,1,2.69,1.18,3.85,3.85,0,0,1,1.67,3.17h0v0l0,4.47h0c0,.13-.05.19-.14.18l-47.82-.51-.32-.69.32.69a.47.47,0,0,1-.26-.15,22,22,0,0,0-9.49-5.14A53.22,53.22,0,0,0,350.33,171a45.86,45.86,0,0,0-12.78,1.22,19.59,19.59,0,0,0-9.36,5.15h0a.11.11,0,0,1-.09,0l-3-.07h0l-65.94-.16-.08,26.8h0c0,.13-.05.19-.14.18H27.62c-2.3,0-2.84-6.78-2.84-13.6,0-3.75.15-7.53.24-10,0-.73.05-1.34.07-1.78-2.21-3-2.06-12.23-1.84-24.79.06-3.38.12-7,.15-10.88A35.75,35.75,0,0,1,24.59,136a35.79,35.79,0,0,0,1.19-6.94c.11-8.7.3-17.43.5-26.19s.39-17.83.5-26.43a6,6,0,0,1,1.86-4.23,6.27,6.27,0,0,1,4.29-1.75h2.34l.33.69Zm272.92,59.93c0,.19,0,.31-.12.3h0c-38.93-5.45-38.91-21.78-38.88-22.59l-2.16-23.06c0-.17,0-.29.11-.28h0l36,1c.07,0,.17.05.28.16a2,2,0,0,1,.49,1l-.44-.45.43.45,4.25,43.49Zm-5-43.27-35.27-1,2.14,22.9h0v.11c0,.86.23,14.91,37.25,20.14l-4.12-42.17Zm24,46.24.28,0a1.52,1.52,0,0,0,1-.47,2.25,2.25,0,0,0,.59-1.08,1.92,1.92,0,0,0,.05-.41V111.52a2.7,2.7,0,0,0-.39-1.15,8.23,8.23,0,0,0-1.24-1.74L311.72,91.54a1.71,1.71,0,0,0-1-.53,1.85,1.85,0,0,0-1.17.24,2.54,2.54,0,0,0-.89.8,1.4,1.4,0,0,0-.34.88l4.5,37.17a.75.75,0,0,0,.15.38,2.58,2.58,0,0,0,1.24.6l13.32,3Zm-12.74-1.64a3.36,3.36,0,0,1-1.69-.9,3.86,3.86,0,0,1-1.14-2.32l-4.5-37.16a1.92,1.92,0,0,1,.39-1.32,3,3,0,0,1,1-.86,2.2,2.2,0,0,1,1.31-.26,2.63,2.63,0,0,1,1.5.88l16.16,17.09a12.65,12.65,0,0,1,1.79,2.54,5.57,5.57,0,0,1,.79,2.4v20.64a2.53,2.53,0,0,1-.73,1.79,1.68,1.68,0,0,1-1.18.53,2,2,0,0,1-.34,0l-13.32-3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "inter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M334.55,117.08l3.7,21.91-28.49-7.14a10.54,10.54,0,0,1,.4-1.12l-.07-.07a1.26,1.26,0,0,1,0-1.79l2.79-2.73a28.61,28.61,0,0,1,2.25-2.55,8,8,0,0,1,1.68-1.29l8.91-8.7a1.26,1.26,0,0,1,1.79,0l.3.3a1.28,1.28,0,0,1,0,1.8l-6,5.84a9.85,9.85,0,0,1,3.29,1.31,23.34,23.34,0,0,1,2.56-4.61c1.95-2.88,6.88-1.18,6.88-1.18ZM263.4,98.65c1.87,6.29,5.32,10.81,7.7,10.1s2.78-6.38.91-12.66-5.32-10.81-7.7-10.1-2.78,6.38-.91,12.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M328.26,134.89a1.72,1.72,0,0,1-.39,0l-13.33-3a2.85,2.85,0,0,1-2.4-2.43l-4.51-37.17a2.27,2.27,0,0,1,.65-1.63,2.77,2.77,0,0,1,2-1,2.46,2.46,0,0,1,1.78.83l16.15,17.09c.7.74,2.21,2.81,2.21,4.19v20.64a2.44,2.44,0,0,1-2.18,2.52Zm-18-44.5a2,2,0,0,0-1.44.73,1.59,1.59,0,0,0-.46,1l4.51,37.16a2.13,2.13,0,0,0,1.81,1.78l13.32,3c.8.19,1.63-.73,1.63-1.72V111.73c0-1-1.16-2.77-2-3.65L311.52,91a1.68,1.68,0,0,0-1.22-.6Zm-2.08,40.42h-.05c-20.3-2.85-29.66-8.58-33.95-12.88-4.55-4.57-4.55-8.49-4.53-8.91L267.53,85.9a.38.38,0,0,1,.4-.42l36.05,1a.38.38,0,0,1,.37.34l4.25,43.56a.37.37,0,0,1-.11.31.39.39,0,0,1-.27.11Zm-4.61-43.56-35.27-1L270.46,109V109c0,.16-.46,15.51,37.33,20.94l-4.18-42.72Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "COLOUR",
    className: "cls-24",
    d: "M33.25,71.19a6.05,6.05,0,0,0-6,5.8c-.2,17.41-.79,35.41-1,52.62,0,3.94-2.36,10.14-2.39,14-.13,18.77-1.11,33,1.7,35.16,0,3.14-1.37,24.64,1.76,24.64H258.64l.07-27,66.08.15,3,.07c4.84-5,12.84-6.63,22.21-6.4s16.4,1.4,22.14,6.74l47.85.51,0-4.5c0-1.65-1.48-2.71-4.18-3.28l-1.57-9.06c1.4-.06,2.18-.05,2-.2-1.68-19.91-16.77-26.23-45.65-33.59l-16.43.57c-11.46-15.59-25.62-30.28-40.54-44.72l3.95-1.51c-3.86-8.09-20.23-10.07-55.84-10.07h-6.55v1.93a1,1,0,0,1-1,1h-1.54a1,1,0,0,1-1-1V73H248a1.49,1.49,0,0,1-1.48-1.48v-.34H222.94v.34A1.48,1.48,0,0,1,221.46,73h-3.57v.11a1,1,0,0,1-1,1h-1.54a1,1,0,0,1-1-1V73H210.7a1.49,1.49,0,0,1-1.48-1.48v-.34H44.27v.34A1.49,1.49,0,0,1,42.79,73H39.22v.11a1,1,0,0,1-1,1H36.63a1,1,0,0,1-1-1V71.19ZM308.1,130.73C269,125.25,270,109.31,270,109.31l-2.17-23.14,36,1,4.26,43.55Zm19.73,4c1.13.26,2.1-.94,2.1-2.1V112c0-1.15-1.3-3.08-2.1-3.92L311.68,91c-1.75-1.85-3.92.33-3.78,1.48l4.5,37.16a2.48,2.48,0,0,0,2.11,2.11l13.32,3Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "body_details",
    "data-name": "body details"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seams"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M25,179.33l4.79-2.78L36,173.07H67.84l5.42,3.48H80l15.11-3.79,16.14,3.79h213c4.27-4.29,9.82-7.13,13-7.82,4.83-1,20.31-2.08,29.68,1.64A20.36,20.36,0,0,1,374,175h-8.33l-.84-.36c-8.22-3.26-21.79-2.35-26-1.43s-13.17,6.13-15.84,13.5c-2.48,6.81-3.33,9.66-3.35,20.61l-.37.38h-3.87c0-.38,0-.75,0-1.11H35.87c-6.58.6-10.63-1-10.91-6V179.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M116,176.55h2.85l12.22-4.12h93.77c9,0,18,4.12,26.92,4.12h72.44a32.68,32.68,0,0,1,5.29-4.27v5.8a26.71,26.71,0,0,0-2.37,2.16H116v-3.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M267.79,86.17l1.38,14.73c-5.9-.63-11.54-1.05-16.54-1.21-1.23,0,.67-3.32-.48-3.33s-.17,3-6.67,3.3c-18.4.79-24.93.28-38.25,1.41s-44.19-.28-64-.28-43.06.28-58.07.85-40.71-1-43.35-1.13c-.71,0-3.8,0-5.51-4.4-.38-1,.39,3.76-.82,3.4a18.16,18.16,0,0,1-8.55-5.28c.13-5.78.23-11.54.3-17.24a6.05,6.05,0,0,1,6-5.8H35.6v1.93a1,1,0,0,0,1,1h1.55a1,1,0,0,0,1-1V73h3.57a1.49,1.49,0,0,0,1.48-1.48v-.34h165v.34A1.49,1.49,0,0,0,210.7,73h3.57v.11a1,1,0,0,0,1,1h1.54a1,1,0,0,0,1-1V73h3.57a1.48,1.48,0,0,0,1.48-1.48v-.34h23.53v.34A1.49,1.49,0,0,0,248,73h3.57v.11a1,1,0,0,0,1,1h1.54a1,1,0,0,0,1-1V71.19h6.55c4.12,0-3.3,11.53,6.1,15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M29.94,96.15,30.16,77a4.9,4.9,0,0,1,.66-2.36c.71-.46,1.15-.72,1.15-.72s242.25-.27,249.69,0,13.43.38,20.94,2.39,11,6.47,11,6.47S303,96.59,271.5,97s-237.23-.23-241.56-.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M37.36,133.32H159a1.64,1.64,0,0,1,1.63,1.64v2.54A1.9,1.9,0,0,1,160,139a1.89,1.89,0,0,0,.14-.72V135.7a1.65,1.65,0,0,0-1.64-1.64H36.74V134a.63.63,0,0,1,.62-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M160.66,136.71v.74a1.89,1.89,0,0,1-1.88,1.9H37.36a.63.63,0,0,1-.62-.64V138a.63.63,0,0,0,.62.64H158.78a1.89,1.89,0,0,0,1.88-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M252.74,88.24a8.35,8.35,0,0,1-1,1.15c.07,1.92.11,3.29.1,3.46l-.7,11.1c-.63,10-3.15,15.46-9.73,18.25l-12,5.07a39.39,39.39,0,0,1-8.39,2H40.41a2.8,2.8,0,0,1-2.92-2.63L37.57,87a7.84,7.84,0,0,1-1.06-1.76,2.9,2.9,0,0,0-.39,1.46V128a3,3,0,0,0,3,3h182.7a36.44,36.44,0,0,0,8.48-2.22l12.13-5.7c6.65-3.13,9.2-9.23,9.84-20.53l.7-12.48a5.47,5.47,0,0,0-.18-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M39.07,83.75H246.66a6.33,6.33,0,0,1,6.08,4.49,9,9,0,0,1-.77.9s0-.08,0-.12a6.28,6.28,0,0,0-6-3.83H40.05a3,3,0,0,0-2.67,1.56,7.64,7.64,0,0,1-.87-1.51,3,3,0,0,1,2.56-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M315.35,206.88v-.34H35.87c-3.92.36-6.93-.07-8.79-1.52H319.56v1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "260.6 73.65 260.6 206.23 261.37 206.23 261.37 73.65 260.6 73.65 260.6 73.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "326.48 173.8 305.51 165.65 146.39 165.65 117.59 176.03 98.41 170.99 74.31 175.6 61.98 167.43 33.17 167.39 33.3 169.28 61.45 169.57 73.26 176.55 98.31 172.39 118.19 176.96 146.39 167.46 305.05 167.46 326.48 173.8 326.48 173.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M27.57,79.7H287.5s10.65,0,13.95.82a13,13,0,0,1,4.19,2,17.34,17.34,0,0,1,3.78,3.54c1.63,2.12,30.51,32,32.5,34V167.7c-7.71,1.17-13.86,4.24-18.35,9.35s-7.3,12.24-8.34,21.51H270V173.88h0a4.88,4.88,0,0,0-2.15-4.52c-1.47-1-3.74-1.4-6.94-1.21l0,.77c3-.18,5.15.21,6.48,1.09a4.15,4.15,0,0,1,1.8,3.86h0v25.45h46.68l0-.34c1-9.28,3.75-16.38,8.19-21.43s10.53-8,18.21-9.14l.34,0V119.76l-.11-.12c-.09-.09-30.9-31.9-32.56-34a18.24,18.24,0,0,0-3.95-3.71,13.88,13.88,0,0,0-4.45-2.11c-3.39-.85-14.09-.85-14.13-.85H27.57v.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "33.09 79.32 33.09 167.58 33.87 167.58 33.87 79.32 33.09 79.32 33.09 79.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "132.41 172.06 132.41 206.23 133.19 206.23 133.19 172.06 132.41 172.06 132.41 172.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "59.93 173.02 59.93 206.23 60.71 206.23 60.71 173.02 59.93 173.02 59.93 173.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "61.78 199.43 35.63 199.43 35.63 200.2 61.78 200.2 61.78 199.43 61.78 199.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M326,174.78c-.54.46-1.06.95-1.56,1.46l-54.52-.05v-2.08h0a4.87,4.87,0,0,0-2.14-4.52c-1.38-.9-3.45-1.34-6.33-1.24v-1.2h44.07L326,174.78Zm-64.55-5.66c2.73-.1,4.66.3,5.9,1.11s1.66,2.16,1.62,3.87h0v2.07h-7.51v-7.06Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "269.75 183.01 261.01 183.01 261.01 182.23 269.75 182.23 269.75 183.01 269.75 183.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "157.02 172.43 157.02 206.23 157.79 206.23 157.79 172.43 157.02 172.43 157.02 172.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44,206.54v-1H40.54v1Zm211.57,0v-1h-3.47v1Zm-23.32,0v-1h-3.47v1Zm-21.78,0v-1H207v1Zm-21.5,0v-1h-3.47v1Zm-23.57,0v-1h-3.47v1Zm-11.2,0v-1h-3.47v1Zm-16.19,0v-1h-3.47v1Zm-79.78,0v-1H54.78v1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "38.67 79.32 38.67 173.07 39.45 173.07 39.45 79.32 38.67 79.32 38.67 79.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M127.22,207.65s-21.06-.08-31.59,0-32.43,0-32.43,0,1.62-21.59,10.39-28.77,34.9-9.18,43.58,1.31S127.22,207.65,127.22,207.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M130,209.41h-4.79c-.35-21.33-8.83-34.07-29.61-33.85-20.77-.22-29.25,12.52-29.59,33.85h-4.8c.16-26.65,11.78-39.77,34.39-39.89,22.62.12,34.24,13.24,34.4,39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M116.43,177c-5.5-4.08-12.78-6.07-21.83-6.12-13.17.07-22.6,4.55-28.22,13.53,5.54-9.61,15.16-14.4,28.78-14.47,9.09,0,16.4,2.06,21.91,6.17,1.47,1-.43.59-.64.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M144.46,164.39l1.38-.43-5.1-5.33s-4.41-7.25-21.11-8.51-35.18-.31-43,0-10,2-11.55,6.09S62,165.56,62,165.56l.46.3C63,164,64,160.79,65,158.08,66.6,154,68.7,152.31,76.58,152s26.35-1.26,43.05,0,21.11,8.51,21.11,8.51l3.72,3.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M100.77,152.09h-3.1c-5.31,0-16,.27-20.8,1.47-6.44,1.63-14.51,3.59-4.73,5.71a137.65,137.65,0,0,0,54.16,0c9.79-2.12,1.71-4.08-4.73-5.71-4.75-1.2-15.49-1.43-20.8-1.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "roof",
    className: "cls-31",
    d: "M35.6,72H32s-.44.26-1.15.72v0H35.6V72Zm0,1.37H32s-.44.26-1.15.72v0h5.45a1,1,0,0,1-.64-.74Zm2.93.74c28.34,0,115.07-.1,176.2-.09a1.08,1.08,0,0,1-.47-.75c-62.58,0-149.72.07-175.09.09a1.05,1.05,0,0,1-.64.75Zm5.11-1.37c31.77,0,109.22-.09,166.06-.09a1.49,1.49,0,0,1-.46-.76c-57.95,0-135.44.07-165.06.1a1.48,1.48,0,0,1-.54.75ZM217.41,74H252a1,1,0,0,1-.49-.75H217.88a1.05,1.05,0,0,1-.47.75Zm5-1.36H247a1.49,1.49,0,0,1-.48-.77h-23.6a1.54,1.54,0,0,1-.47.77ZM254.64,74c14,0,23.05,0,24.21.09,6.07.22,11.52.12,16.14.8L293,74.36a110.36,110.36,0,0,0-11.38-1c-1.12,0-11.13-.07-26.53-.08a1,1,0,0,1-.49.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "59.81 79.32 59.81 173.07 60.58 173.07 60.58 79.32 59.81 79.32 59.81 79.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "61.36 79.32 61.36 173.07 60.58 173.07 60.58 79.32 61.36 79.32 61.36 79.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "157.02 79.32 157.02 172.43 157.8 172.43 157.8 79.32 157.02 79.32 157.02 79.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "158.57 79.32 158.57 172.43 157.8 172.43 157.8 79.32 158.57 79.32 158.57 79.32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "rear_bumper",
    "data-name": "rear bumper"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M25,179.33l4.79-2.78,6-3.32v33.32c-6.5.57-10.49-1.07-10.77-6V179.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M35.79,206.54c-.33,0-.65.06-1,.07V187.82a4.52,4.52,0,0,0-4.51-4.51H25v-1h6.32a4.52,4.52,0,0,1,4.51,4.51v19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M29.68,206H16a1.27,1.27,0,0,1-1.27-1.26v-3.8A1.27,1.27,0,0,1,16,199.63H29.68A1.27,1.27,0,0,1,31,200.9v3.8A1.27,1.27,0,0,1,29.68,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M30.42,198.82H24.66a.5.5,0,0,1-.53-.46V197a.5.5,0,0,1,.53-.46h5.76A.5.5,0,0,1,31,197v1.4a.5.5,0,0,1-.53.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M25.1,193h-1s-.09-.31-.09-.7v-2.09c0-.38,0-.69.09-.69h1s.08.31.08.69v2.09c0,.39,0,.7-.08.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M24.88,198.82h-.69s-.06-.21-.06-.46V197c0-.25,0-.46.06-.46h.69s.07.21.07.46v1.4c0,.25,0,.46-.07.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "door"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M27.74,94.22h-2c-.1,0-.18-.54-.18-1.2V89.41c0-.66.08-1.2.18-1.2h2c.1,0,.19.54.19,1.2V93c0,.66-.09,1.2-.19,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M25.58,93h0v-.27H27c.1,0,.18-.28.18-.61V90.29c0-.33-.08-.61-.18-.61H25.58v-.27h1.67c.12,0,.21.33.21.72V92.3c0,.4-.09.73-.21.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M26.46,189.76h-2c-.1,0-.18-.54-.18-1.21v-3.61c0-.66.08-1.2.18-1.2h2c.11,0,.19.54.19,1.2v3.61c0,.67-.08,1.21-.19,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M24.3,188.56h0v-.27h1.38c.1,0,.19-.27.19-.61v-1.84c0-.34-.09-.62-.19-.62H24.3v-.27H26c.12,0,.21.33.21.73v2.18c0,.4-.09.72-.21.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rear_signal",
    "data-name": "rear signal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M24.81,179l.71.15,10.2-5.86.43-40.41-9.72-3.6s-1.09,0-1.11,2.24S24.81,179,24.81,179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M25.37,130.77a5.08,5.08,0,0,0-.05.72l-.51,47.38,10-6,.39-37a5.25,5.25,0,0,0-1.82-2.64,30.92,30.92,0,0,0-8-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M33,145.8a96.13,96.13,0,0,1,1.1,11.27c.27,6.49.17,6.69.28,8.56a29.82,29.82,0,0,1,.25,5.16c-.19,1.64-.8,1.49-.82.46s-1.41-.79-2.16.05-2.06,1.65-1.28,2,.16,1.26-1.17,2.1-1.57.87-1.25-.21-.68-.54-.8-1.28a31.35,31.35,0,0,1,1-5L33,145.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M25,158.45l-.17,16.12c1.25-2.1,3.39-4.27,5.81-6.92,3-3.32,1.8-5.31,2.28-9s.62-23.77.62-23.77l-2-.87-.49,10.87a39.6,39.6,0,0,1-1,7c-.61,2.57-3.52,5.21-5.12,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M25,158.45,25,165.64c2.77-1.83,2.37-3.77,2.46-5.19,0-.74-.8-1.74-1.7-2.57l-.69.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M31.29,140.68l-.19,4.24a39.6,39.6,0,0,1-1,7c-.56,2.36-3,4.76-4.68,6.14a2.73,2.73,0,0,0,2,2.35s.06-1.28.07-2.19.25-1.34,2.31-4.23c1.6-2.26,1.61-10,1.46-13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M30.2,144.23c-.23,1.65-1.55,2.39-2.59,3.62s-.48,3.45-.48,3.45a4.07,4.07,0,0,1,1.45-3.11c1.54-1.26,1.62-4,1.62-4Zm.08-6.81c-.24,1.65-1.56,2.39-2.6,3.62s-.48,3.45-.48,3.45a4.07,4.07,0,0,1,1.45-3.11c1.54-1.26,1.63-4,1.63-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M27.38,133.11c.18,0,.32,1.1.3,2.52a5.9,5.9,0,0,1-.35,2.63A4.66,4.66,0,0,1,26,135.2a2.27,2.27,0,0,1,1.38-2.09Zm-.17,16.12c.18,0,.31,1.1.3,2.53a5.65,5.65,0,0,1-.36,2.62,4.67,4.67,0,0,1-1.33-3,2.31,2.31,0,0,1,1.39-2.1Zm.08-8c.18,0,.32,1.1.3,2.52a5.72,5.72,0,0,1-.35,2.62,4.62,4.62,0,0,1-1.33-3.05,2.26,2.26,0,0,1,1.38-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M32.87,133.77c-1.11-.34-2.16-.34-2.34,0s.58.89,1.69,1.23,2.17.34,2.35,0S34,134.11,32.87,133.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M24.94,167.15l-.13,11.73,2.35-9.9a15.81,15.81,0,0,1-2.22-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M32.1,147.78,31.91,152a40.12,40.12,0,0,1-.94,7c-.56,2.36-3,4.77-4.69,6.15.29,2,1.15,1,1.15,1a2.11,2.11,0,0,0,.21-1.16c0-.91,1.17-1.37,3-3.94s1.61-10,1.46-13.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M30.71,174.14c-2,1.3-3.55,2.48-3.44,2.66s1.84-.75,3.85-2,3.56-2.49,3.45-2.66S32.73,172.84,30.71,174.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M34.24,170.72a6.48,6.48,0,0,0-.07-2.91c-.43-1.15-1.43.83-2.25,1.74s-3.7,3.48-3.7,3.48.2.82,1.77-.54,4.28-4,4.25-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M27,173.73s-.67-.75.36-1.67,3.86-2.86,5-5.32a13.89,13.89,0,0,0,1.18-5.29s.62,4.65-.88,6.31-3.39,3.1-4.24,4.05S27.74,174,27,173.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M26.89,161.5c-.7-.57-1.41-.89-1.58-.73s.27.77,1,1.34,1.41.89,1.58.73S27.59,162.07,26.89,161.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M26.51,162.27c-.56-.23-1.14-.23-1.28,0s.2.59.77.82,1.14.23,1.28,0S27.08,162.49,26.51,162.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M26.49,162.89c-.47,0-.91.08-1,.28s.27.41.74.46.91-.08,1-.29S27,162.93,26.49,162.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M26.56,166.69c-.48-.49-1-.79-1.14-.67s.11.64.58,1.13,1,.8,1.14.67S27,167.19,26.56,166.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M26.08,160.34c.42.38.84.62,1,.52s-.15-.48-.57-.87-.84-.62-.95-.52S25.66,160,26.08,160.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cab"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M360.21,127l10.46-.36c16.94,4.31,29.13,8.27,36.65,14.82-1.53-.55-3.67-1.33-6.65-2.44-10.35-3.87-32.52-9.9-40.46-12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M316.81,79.55a8.46,8.46,0,0,1,.84,1.41l-3.95,1.51-1.05-1.11,4.16-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M335.23,104.36c-8.3-8-21.75-21.65-21.75-21.65L271.41,82s-5.37.67-5,5.2,2.35,23.32,2.35,23.32-1.35,13.42,23,18.93S332.76,138,332.76,138l.05,2.23,9.62,2,40.16,8.39,3.69,4.19s10.83,1.83,13.12,2.92,4.92,2.73,6.34,2.62a3.54,3.54,0,0,0,2.24-1,16.3,16.3,0,0,1,3.44,3.77c1.2,2,2.51,4.42,2.51,4.42l1.88,1.3-1.42-8.18a4.78,4.78,0,0,1-2.46-2.52,32.93,32.93,0,0,0-5-7.84c-1.73-1.73-2.88-2.59-7.7-4.17s-24.68-6.7-28.57-7.56-9.14-1.51-9.14-1.51-3.08-4.33-7.23-9.88h-.09a270.14,270.14,0,0,0-19-22.83Zm-27,26.06C269.14,124.94,270.08,109,270.08,109l-2.16-23.15,36.05,1,4.25,43.55ZM328,134.47c1.13.25,2.11-.95,2.11-2.1V111.73c0-1.16-1.31-3.08-2.11-3.92L311.8,90.72c-1.75-1.85-3.92.33-3.78,1.47l4.51,37.17a2.45,2.45,0,0,0,2.1,2.1l13.32,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M368.13,138.68s-9.66.77-16.3-6.86c-5.7-6.55-10.42-21.82-39.87-49.13l1.52,0s13.45,13.6,21.75,21.65a270.14,270.14,0,0,1,19,22.83h.09c4.15,5.55,7.23,9.88,7.23,9.88s3.3.41,6.61,1l0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M361.56,137.06s5.26.65,9.14,1.51,23.75,6,28.57,7.56,6,2.44,7.7,4.17a17.21,17.21,0,0,1,1.86,2.35c2,3.33,4,7.35,5.51,7.76-.48.5-1.88-.63-5.65-6l-.43,5.19-.28-.24a3.54,3.54,0,0,1-2.24,1c-1.42.11-4-1.53-6.34-2.62s-13.12-2.92-13.12-2.92l-3.69-4.19-13.25-2.77-7.78-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M258.94,176.24h65.39c4.27-4.28,9.83-7.12,13-7.81,4.83-1.05,20.31-2.09,29.69,1.63a20.43,20.43,0,0,1,7,4.59h-8.32c-.28-.13-.56-.25-.85-.36-8.22-3.26-21.78-2.35-26-1.44s-13.18,6.13-15.85,13.5c-2.47,6.81-3.33,9.67-3.34,20.61l-.38.38h-3.86v-1.11H258.94v-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M258.94,176.24h65.39a33.22,33.22,0,0,1,5.3-4.26v5.79a26.94,26.94,0,0,0-2.38,2.17H258.94v-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M417.44,177.13h-3.16a1.27,1.27,0,0,0-1.26,1.26v3.2a1.26,1.26,0,0,0,1.26,1.25h3.16a1.25,1.25,0,0,0,1.25-1.25v-3.2a1.26,1.26,0,0,0-1.25-1.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 417.21,
    y: 193.47,
    width: 5.67,
    height: 8.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M374.73,175.32c.28.3-1.56-1.55-1.31-1.23,7.11-4.73,14.61-7.71,21.29-7.4l12.17,1.53c2.36.41,5.06,1.63,6.18,3.71l2.31,5.31.75,1s1.6,11.07,2.18,12.14,2.3,1.69,3.55,2.2l0,.29-1.41,7.33c-1.61,3.39-6.66,5-13.82,5.38l-22.52.67c0,.61,0,1,0,1l0,.15H380.3l-.36-.38,0-.13s-.19-10.5-2.28-16.37c-1.89-5.31-4-11.57-10.52-15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M414.22,177.3l0,.06-1,.53s-1.9-3.68-3.88-4-7.92-1.09-9.77-1.33l.24-.33c1.56.2,8,1,10,1.35s3.88,4,3.89,4l.55-.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "395.75 175.73 395.75 175.56 395.86 175.4 398.63 171.58 398.83 171.3 399.04 171.33 396.31 175.1 396.19 175.26 396.2 175.43 397.27 175.43 397.05 175.73 395.75 175.73 395.75 175.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M421.64,194.1l-.22,1.16.15-.77h-4.06l-.07,0a8.72,8.72,0,0,0-3.28,1.54c-.24.22-.43.41-.6.58-.43.45-.62.65-2,.65a9.81,9.81,0,0,1-5.08-1.12l-.68-.31h0c-2.16-.95-4.9-2.17-6.63-5.21a15.69,15.69,0,0,1-1.77-4.43,18.36,18.36,0,0,1-.37-3.53c-.06-1.54-.12-4.3-.15-5.69h-1.14v-.39h1.15c0,1.39.09,4.14.15,5.69a18.36,18.36,0,0,0,.37,3.53,15.8,15.8,0,0,0,1.77,4.43c1.73,3,4.47,4.26,6.63,5.21h0l.68.31a13.18,13.18,0,0,0,2.64.94,12,12,0,0,0,2.44.17c1.34,0,1.53-.19,2-.64.17-.17.36-.37.6-.58a8.72,8.72,0,0,1,3.28-1.54l.07,0h4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M420.34,200.43c-1.75,3.22-6.72,4.72-13.69,5.13l-22.52.67c0,.62,0,1,0,1l0,.15H380.3l-.36-.38,0-.13s-.19-10.5-2.28-16.37c-1.89-5.3-4-11.57-10.52-15.14h7.43c.52.42,1.49,1.6,3.31,4.58,3.73,6.13,5.3,15.69,5.3,15.69s-.51.88,1.34,2.72,7.4,2,7.4,2l28.44.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M412.82,177.56a12.57,12.57,0,0,1,2.05,4.69,32.62,32.62,0,0,1,.65,6.19c-.14,1-.93,1.61-2,3.08s-1,1.9-2.27,1.9a23.48,23.48,0,0,1-6.13-.69c-2-.62-3.36-1.28-4.24-3.08s-.62-6.78-.86-8.24-.59-4-.59-4l13.35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M413.15,177.3A12.57,12.57,0,0,1,415.2,182a32.62,32.62,0,0,1,.65,6.19c-.15,1-.94,1.62-2,3.08s-1,1.9-2.28,1.9a23.44,23.44,0,0,1-6.13-.69c-1.95-.62-4-1.14-4.92-2.93s-1-6.93-1.26-8.39a27.6,27.6,0,0,0-1.2-4l15,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M413.52,191.81c-.67,1-.82,1.35-1.9,1.35a23.44,23.44,0,0,1-6.13-.69,15.64,15.64,0,0,1-3.36-1.3c6.16-.87,9.54-.24,11.39.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M415.8,188.42c-.22.89-1,1.49-1.9,2.84s-1,1.73-1.74,1.86c-4.48-3.06-.54-5.23-.54-5.23l4.18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M400.23,188.59a69.23,69.23,0,0,1-.92-7.44,27.6,27.6,0,0,0-1.2-4l11.74.14,2.23,3.67a24,24,0,0,1,.75,5.79,8,8,0,0,1-1.68,4.65c-.69.88-4.08.55-5.52.48s-3.9-1.07-4.41-2.09a5.15,5.15,0,0,0-1-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M403.83,188.4h.4l.26-.49.26-.52-.25-.48-.24-.46h-.86l-.24.46-.26.52.26.51.24.47Zm8.12-7.7h-1.49l-.07.14-.31.59-.3.59h-1l-.18-.35-.31-.6-.07-.13h-1.6l-.07.13-.3.6-.16.3h-.9l-.22-.42-.3-.6-.08-.13H403l-.06.13-.32.6-.3.6-.05.08.05.08.3.59.27.52-.27.51-.3.6-.05.08.05.08.3.6.32.6.06.13h0l-.06.13-.32.6-.3.6-.05.08.05.08.3.6.27.51-.27.51-.3.6-.05.08.05.08.3.6.32.6,0,0,.2.09h1.08l.22.43v0c.23.06.45.1.66.14l-.17-.33-.24-.48.26-.51.26-.5H406l0,0,.31.59.24.48-.2.38-.2.4.57,0,.14-.27.16-.3h1.07l.18.35.14.28H409l-.22-.43-.27-.52.27-.51L409,190h.87l.24.46.26.51-.26.52-.18.34a3.15,3.15,0,0,0,.67-.15l0,0,.29-.59h.46c.09-.14.19-.28.28-.44h-.81l-.24-.46-.23-.44.25-.47.29-.58h.79l.24.46.24.47c.09-.21.17-.43.25-.67l-.25-.47.26-.52.32-.59,0-.06v-.05l0-.06-.32-.59-.3-.6-.07-.13h0l.07-.13.3-.6.31-.59a1.8,1.8,0,0,0,0-.22l-.29-.54-.26-.52.26-.51,0-.06c-.19-1-.39-1.8-.39-1.8l-.13-.23Zm-.69,2.39h.43l.24-.46.26-.52-.26-.51-.24-.46h-.86l-.24.46-.27.51.27.52.24.46Zm-.94.26-.22-.44-.24-.46H409l-.23.46-.27.51.27.52.23.46h.79l.3-.58.24-.47Zm1.37.17h-.79l-.29.58-.25.47.23.44.24.46h.86l.24-.46.26-.51-.26-.52-.24-.46Zm-1.91,3.7h0Zm1.48-.88h-.43l-.24.46-.27.51.27.52.24.46h.86l.24-.46.26-.52-.26-.51-.24-.46Zm-.94,2.21-.22-.44-.24-.46H409l-.23.46-.27.52.27.51.23.46h.79l.3-.58.24-.47Zm-2.25-2.41h0Zm1.79-1.31H409l-.23.47-.27.51.27.51.24.47h.86l.24-.47.26-.51-.26-.51-.24-.47Zm-2.4-1.51h.43l.24-.46.27-.51-.27-.52-.24-.46H407l-.24.46-.19.39.24.48.31.59,0,0Zm-1.5,1.46h-.69l-.26.5-.26.51.24.48.24.46h.87l.23-.46.2-.38-.24-.48-.31-.6,0,0Zm1.93-1H407l-.24.46-.19.38.24.48.31.6,0,0h.72l.24-.46.27-.52-.27-.51-.24-.46ZM406,182.4h-.69l-.26.49-.26.52.24.48.24.46h.87l.23-.46.2-.39-.24-.47-.31-.6,0,0Zm.17,4.77h0Zm-.17.43h-.69l-.26.5-.26.51.24.48.24.46h.87l.23-.46.2-.38-.24-.48-.31-.6,0,0Zm1.5,1.36H407l-.24.46-.19.38.24.48.31.6,0,0h.72l.24-.46.27-.52-.27-.51-.24-.46Zm0-2.39H407l-.24.47-.19.38.24.48.31.59,0,0h.72l.24-.46.27-.51-.27-.51-.24-.47Zm-2.71-2-.25-.48-.24-.46h-.86l-.24.46-.26.51.26.52.24.46h.83l.26-.5.26-.51Zm0-2.39-.25-.48-.24-.46h-.86l-.24.46-.26.52.26.51.24.46h.83l.26-.49.26-.52Zm0,7.59-.25-.48-.24-.46h-.86l-.24.46-.26.51.26.52.24.46h.83l.26-.5.26-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M405.05,182.07c-2.71,0-4.9,1.91-4.9,4.26s2.19,4.27,4.9,4.27,4.9-1.91,4.9-4.27S407.75,182.07,405.05,182.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M405.05,182.07a4.65,4.65,0,0,0-4.89,4.06h9.78a4.65,4.65,0,0,0-4.89-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M406.26,182.07a4.31,4.31,0,1,0,3.69,4.26A4,4,0,0,0,406.26,182.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M406.21,182.69c-1.68,0-3,1.63-3,3.64s1.36,3.65,3,3.65,3-1.63,3-3.65S407.89,182.69,406.21,182.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M403.22,187a5.09,5.09,0,0,0,.14.56,28,28,0,0,0,4.33.74l1,.1a4.08,4.08,0,0,0,.44-1.07c-.4-.05-.82-.11-1.25-.15a25.44,25.44,0,0,0-4.66-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "411.15 182.18 400.98 180.71 400.01 177.19 403.49 177.34 411.15 182.18 411.15 182.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "401.83 177.17 412.32 177.29 413.66 180.64 411.06 182.06 402.61 180.09 401.83 177.17 401.83 177.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "412.36 177.4 413.66 180.64 411.46 181.84 411.15 181.73 403.06 179.69 411.94 180.58 411.57 177.84 412.36 177.4 412.36 177.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M400,182.65a1.12,1.12,0,1,0,1.12-1A1.06,1.06,0,0,0,400,182.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M415.44,178.74c1.6.21,2.79.35,3.67.41a10.91,10.91,0,0,0,2,.07c.46-.1.29-.42.33-.77a1.24,1.24,0,0,0-.28-1.11c-.76-.58-2.64-.68-5.08-.93l-.61-.06v2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M368.39,176.09c11.18.37,36.41,1.27,42.72,2.08l2,.26v-2.27c-7.95-.61-29-2-50.71-2.71a22.91,22.91,0,0,1,2.54.84,18.86,18.86,0,0,1,3.47,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M368.39,176.09c11.18.37,36.41,1.27,42.72,2.08l2,.26v-1.57c-7.66-.59-27.52-1.89-48.32-2.63l.15.06a18.86,18.86,0,0,1,3.47,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M411.24,176.72c-8.69-.63-27.17-1.8-46.47-2.49l.15.06a18.9,18.9,0,0,1,2.26,1.07c11.49.38,35.88,1.26,42.08,2.06l2,.26v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M411.2,178.18c2.4.31,4.26.57,5.7.74V176.5l-.85-.09c-.7-.07-2.38-.21-4.85-.39v2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M420.34,200.43l-28.44-.14s-5.56-.13-7.4-2a7.75,7.75,0,0,1-.83-1,80.51,80.51,0,0,1,.5,8.88l22.48-.67c7-.41,11.94-1.91,13.69-5.13Zm-36.18,6.63v.28h0l0-.15v-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M421.49,194.84l-.07.39h-3.8a7.29,7.29,0,0,0-2.69,1.26c-.23.2-.39.37-.54.52-.67.7-1,1-2.79,1a12.31,12.31,0,0,1-2.67-.21,13.42,13.42,0,0,1-2.89-1l-.67-.31h0c-2.3-1-5.25-2.33-7.17-5.71a16.64,16.64,0,0,1-1.89-4.75,19.07,19.07,0,0,1-.4-3.73c-.06-1.73-.12-4.39-.14-5.74h0c0,1.42.08,3.8.14,5.38a19.07,19.07,0,0,0,.4,3.73,16.69,16.69,0,0,0,1.89,4.76c1.92,3.37,4.87,4.68,7.17,5.7h0l.67.3a13.54,13.54,0,0,0,2.89,1,13,13,0,0,0,2.67.2c1.82,0,2.12-.3,2.79-1,.15-.14.31-.31.54-.51a7.36,7.36,0,0,1,2.69-1.27h3.8l.07,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "269.75 181.46 261.01 181.46 261.01 182.23 269.75 182.23 269.75 181.46 269.75 181.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "260.72 73.35 260.72 205.92 261.49 205.92 261.49 73.35 260.72 73.35 260.72 73.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M270.3,82.3l-.43-.18s-6.22.5-5.88,5S266.76,112,266.76,112s-1.34,13.42,23,18.94,41.05,8.52,41.05,8.52l2,.2,0-1.66s-16.72-3-41.05-8.52-23-18.93-23-18.93-2-18.79-2.35-23.32c-.24-3.19,2.37-4.47,3.92-4.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M308.22,130.42C269.14,124.94,270.08,109,270.08,109l-2.16-23.15,36.05,1,4.25,43.55ZM328,134.47c1.13.25,2.11-.95,2.11-2.1V111.73c0-1.16-1.31-3.08-2.11-3.92L311.8,90.72c-1.75-1.85-3.92.33-3.78,1.48l4.51,37.16a2.45,2.45,0,0,0,2.1,2.1l13.32,3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "308.74 83.14 342.7 119.02 342.7 116.95 308.74 83.14 308.74 83.14"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M415.59,169.06s-7.8-6.51-24.86-10.06-48-7-58-7-16.87-.49-21.9,2.66a19.32,19.32,0,0,0-8.54,10.64l3.43.09,2.68,1.13c1.31-3,5-7.17,15.25-7.91,16.48-1.18,39-.49,54.55,1.87s25.05,3.65,37.39,8.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M312.65,81.36a14.36,14.36,0,0,0-1-4.82,5.51,5.51,0,0,0-4.46-3.37c-2.09-.39-9.3-.82-9.3-.82a2.74,2.74,0,0,0-2.2,1.05c-.65,1.07-.46,1.09-.46,1.09s11.89,1,17.4,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M312.2,78.08a10.37,10.37,0,0,0-.53-1.54,5.4,5.4,0,0,0-2.44-2.71c-1,0-1.39.27-1.36,1.08,0,1.09.16,1,1.05,2a4.78,4.78,0,0,0,1.35,1.16l1.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M317.65,81a436.3,436.3,0,0,1,44.81,45.94l-8.22.29c-10.89-15.08-25-29.85-40.76-44.48L317.65,81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "361.56 137.06 369.98 148.02 371.24 148.29 362.54 137.19 361.56 137.06 361.56 137.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "400.43 175.29 400.43 158.33 400.12 158.33 400.12 175.29 400.43 175.29 400.43 175.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M415.59,168.74s-7.8-6.6-24.86-10.35-48-7.58-58-7.7-16.87-.7-21.9,2.4a18.94,18.94,0,0,0-8.54,10.53l.63,0a19.26,19.26,0,0,1,7.91-8.95c5-3.14,11.93-2.62,21.9-2.58s40.93,3.59,58,7.2c11.63,2.47,19,6.29,22.44,8.47l2.42,1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M412.45,156.47s-3.36-7.24-4.89-9.7a13.06,13.06,0,0,0-7.13-5.35c-3.09-1-40.8-12.48-40.8-12.48s-.56-.2.18,2.59a5.64,5.64,0,0,0,2.7,3.71l37.83,10.11s6.48,1.07,12.11,11.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M265.39,139.85h4.5c1,0,1.51.92,1.89,1.89a17.14,17.14,0,0,1,0,12.6c-.35,1-.85,1.89-1.89,1.89h-4.5c-1,0-1.55-.9-1.89-1.89a19.1,19.1,0,0,1,0-12.6c.32-1,.85-1.89,1.89-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M266.15,142.54h3c.69,0,1,.58,1.26,1.18a10.1,10.1,0,0,1,0,7.91c-.23.61-.57,1.18-1.26,1.18h-3c-.7,0-1-.57-1.27-1.18a11.33,11.33,0,0,1,0-7.91c.22-.61.57-1.18,1.27-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M265.89,145.29c-.11-.24-.24-.38-.36-.38-.41,0-.73,1.28-.73,2.87s.32,2.87.73,2.87c.12,0,.25-.14.36-.39a6.87,6.87,0,0,1-.36-2.48,7,7,0,0,1,.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M268.48,140.77h-1.69a.52.52,0,0,0-.57.44v12a.52.52,0,0,0,.57.44h1.69a.52.52,0,0,0,.57-.44v-12a.52.52,0,0,0-.57-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M265.5,142.54H266c-.7,0-1.05.57-1.26,1.18a11.22,11.22,0,0,0,0,7.91c.22.61.57,1.18,1.26,1.18h-.51c-.7,0-1-.57-1.27-1.18a11.33,11.33,0,0,1,0-7.91c.22-.61.57-1.18,1.27-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M268.25,141.1H267a.41.41,0,0,0-.42.41v11.42a.42.42,0,0,0,.42.41h1.23a.42.42,0,0,0,.42-.41V141.51a.41.41,0,0,0-.42-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M268.49,145.75a18.49,18.49,0,0,1-.25,4.29,17.53,17.53,0,0,1-.26-4.29,17.48,17.48,0,0,1,.26-4.28A18.44,18.44,0,0,1,268.49,145.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M268.4,154.43a.77.77,0,1,1-.76-.76A.76.76,0,0,1,268.4,154.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M267.06,153.24a1.33,1.33,0,0,0,.58,2.52h.14a1.54,1.54,0,0,1-1.14-1.33,1.28,1.28,0,0,1,.42-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M271.08,141.31a5.8,5.8,0,0,1,.41.87,15.15,15.15,0,0,1,.95,8A7.71,7.71,0,0,1,271,153a12.92,12.92,0,0,0-.07-10,2.75,2.75,0,0,0-1-1.35c.07-.23.38-.38,1.14-.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M409,155.15h.4l.26.49.26.52-.25.48-.24.46h-.86l-.24-.46-.27-.52.27-.51.24-.46Zm-.41-2.82h-.23l-.21.09,0,.05-.31.59-.3.6-.05.08.05.08.3.6.27.51-.27.52-.3.59-.05.08.05.08.3.6.31.59.07.14h0l-.07.14-.31.59-.3.6-.05.08.05.08.26.51.18-.18.57.49-.2-.39-.27-.51.27-.52.24-.46h.83l.26.5.26.51-.25.48-.24.47h-.81l.47.43h.31l.26.5.07.14c.2.21.41.44.62.69l.05-.1h.9l.1.18h-.1l.2.4.2.38-.25.48-.05.1.39.66.22-.43.31-.59,0,0h.72l.24.46.27.52-.27.51-.24.46h-.75l.24.44h.51l.24.46.27.51-.23.43c.25.45.43.78.52.93l.07-.13.23-.46h.87l.24.46.26.51-.26.52-.05.1.46.32.07-.13-.52-3-.2.38h-.87l-.23-.46-.27-.51.27-.52.23-.46H415v0l-.08-.45h-.72l-.23-.46-.27-.52.27-.51.22-.43h-.24l.08-.16h.53l-.08-.43h-.28l-.23-.46-.14-.27a4.4,4.4,0,0,1-.73-.58h-.86l-.24-.46-.2-.38.25-.48,0-.06c0-.08-.08-.17-.13-.26l-.22-.46-.24.45-.3.6,0,0h-.69l-.26-.5-.26-.51.24-.48.24-.46h.85l-.22-.44h0l-.24-.43h-.35l-.26-.49-.26-.52.14-.28c-.1-.18-.21-.36-.32-.54l-.07.14-.24.46h-.86l-.24-.46-.27-.51.27-.52.24-.46h.32l-.3-.43Zm6.36,14.1h0Zm-2.32-6.21h.43l.24.46.27.51-.27.52-.24.46h-.86l-.24-.46-.2-.39.25-.47.31-.6,0,0Zm-1.5.92h-.69l-.26-.49-.26-.52.24-.48.24-.46h.86l.24.46.2.39-.25.47-.3.6,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M408.32,153.17l-.47,5.13s-.26,1.82-2.62,1.51-4.18-2.35-7.74-3.34-9.68-2-9.68-2a5.5,5.5,0,0,1-1.89-.94c-.57-.58-2.19-2.57-2.19-2.57a4.47,4.47,0,0,0-2.51-1.15c-1.78-.31-10.35-2-10.35-2l-7.94-10.14,10.4,2.08L400,147.15a17.39,17.39,0,0,1,8.37,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M408.28,153.6l-.2,2.15a16.69,16.69,0,0,0-3.11-3.82c-2.07-1.78.6-1.61,3.31,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M407.49,159.09a2.23,2.23,0,0,1-2.26.72c-2.36-.3-4.18-2.35-7.74-3.34-.9-.26-2-.51-3.06-.74l-1.16-2.35a28,28,0,0,1,6.65,1.57c3.2,1.25,4.73,3.32,6.32,4.19a1,1,0,0,0,1.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M378.19,149.24c-3.12-.61-7.32-1.46-7.32-1.46l-7.94-10.14,10.4,2.08,5.68,1.59-2.25,2.23,1.43,5.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "363.34 137.73 373.33 139.72 379.01 141.31 377.95 142.36 365.49 138.9 363.34 137.73 363.34 137.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M381.49,149.88l-.27-.06c-1.78-.31-10.35-2-10.35-2l-7.94-10.14.21.05h0l2.35,1.21,5.78,7.34,8.58,2,1.64,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M400.53,157.7a15,15,0,0,0-3-1.23c-3.56-1-9.68-2-9.68-2a5.5,5.5,0,0,1-1.89-.94c-.57-.58-2.19-2.57-2.19-2.57a4.55,4.55,0,0,0-2.51-1.15l-3.59-.69-2-5.7a16.93,16.93,0,0,1,1.46-1.71,3.55,3.55,0,0,1,1.25-.6L398,146.6a78.27,78.27,0,0,1,2.58,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M384.18,142.75l6.19,1.73a15.31,15.31,0,0,1,2.72,2.36c.62.79-5.43-2.29-8.91-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M397.91,149.07a97.85,97.85,0,0,0-12.41-2.9c-6.25-1-9.09-.54-9.09-.54l1,2.44s10.06.57,20.53,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M400.54,157.7a15.74,15.74,0,0,0-3.05-1.23c-1.51-.42-3.47-.84-5.23-1.19a15.74,15.74,0,0,1-.14-2.64c.14-1.72.84-1.81,3.18-3.13a3.4,3.4,0,0,1,4,.26l1.22,7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M395.82,156c-1.08-.25-2.24-.5-3.35-.72-.19-1.16-.45-2.44,1.33-3,2.25-.75,3.57-.22,3.13.88-.3.76-.81,2.11-1.11,2.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "399.12 149.94 397.24 151.54 397.38 152.06 399.41 152.26 399.12 149.94 399.12 149.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M392.74,154s.13-.53,1.24-1.06a9.52,9.52,0,0,1,2.95-.62,6,6,0,0,0-2.69-.4c-1.5.14-2.6.84-1.5,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M398.87,154.27a9.39,9.39,0,0,1-3,1.28c-1.34.2-1.14-.48-.79-1.32A3.55,3.55,0,0,1,396,153s-.39,2.07,2.91,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M399.4,152.9c.39-.06.75,4.2.75,4.2a15.91,15.91,0,0,0-2.33-1.06c-.89-.27,1.72-.31,1.58-3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M395.4,148.39c.69.08,1.1.17,1.1.25s-1.91.27-4.26.19-4.24-.28-4.23-.46.47-.15,1.23-.19h0l3.35-.54c1-.17-4.21-.57-4.21-.57A9.84,9.84,0,0,1,391,147c1.13.17-1.11-.77-1.11-.77s2.58.77,3.78,1.27-.23-1-.23-1a21.75,21.75,0,0,1,2.37,1.2c1,.61-.43.69-.43.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M383.52,146.41c-3.41-.27-6.19-.11-6.21.37s2.75,1.09,6.17,1.36,6.19.12,6.2-.36S386.94,146.69,383.52,146.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M383.52,147c-3.41-.24-6.19-.29-6.21-.11s2.75.52,6.17.76,6.19.29,6.2.11S386.94,147.22,383.52,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M385.06,152.57c.51-.12,1.23-.39,1.14-.95-.13-.87-.59-1.94-2.6-2a9.64,9.64,0,0,0-2.2.25,4.36,4.36,0,0,1,2.33,1.11s.69.85,1.33,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M383.45,150.72a2.46,2.46,0,0,1,.28.25s.27.34.63.77c.91,0,1.6-.15,1.61-.39s-.85-.55-1.94-.61c-.2,0-.4,0-.58,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M380.68,148.28c-1.85-.05-3.36.06-3.37.26s1.5.4,3.36.46,3.36-.06,3.36-.26S382.54,148.34,380.68,148.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M382.4,149c-1.58,0-2.88.09-2.88.29s1.28.37,2.87.41,2.88-.09,2.88-.28S384,149,382.4,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M377.55,141.92a27.09,27.09,0,0,1,6.15,1.81c1.84,1,2.44,1.54,1.6,1.74s4.11,1.37,3.08.23-2.81-2.81-10.83-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M378.09,142.29c.05-.25,4.34,1.34,3.84,2.24s-4,.6-4.71.6,1.07-.33,1.5-1.17-.63-1.67-.63-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M400.53,157.68a16.06,16.06,0,0,0-3-1.25c-3.52-1-9.59-2.11-9.59-2.11a5.58,5.58,0,0,1-1.87-.94c-.57-.57-2.18-2.54-2.18-2.54a4.61,4.61,0,0,0-2.49-1.16c-.6-.11-2-.4-3.56-.73l-2-5.58a16.76,16.76,0,0,1,1.44-1.64,1.84,1.84,0,0,1,.44-.27l-.15.11a17.35,17.35,0,0,0-1.45,1.64l2,5.58c1.56.33,2.95.62,3.55.73a4.57,4.57,0,0,1,2.49,1.17s1.61,2,2.18,2.53a5.46,5.46,0,0,0,1.86.95s6.08,1.07,9.6,2.1a14.41,14.41,0,0,1,2.67,1.07l.06.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M330.06,112.3v-.57c0-1.16-1.31-3.08-2.11-3.92L311.8,90.72c-1.75-1.85-3.92.33-3.78,1.48l1.89,15.58c7.73,1.52,14.42,3,20.15,4.52ZM305.93,107l-2-20.14-36.05-1,1.45,15.58c14.07,1.72,26.19,3.63,36.56,5.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M335.8,111.76h4.75a3.38,3.38,0,0,1,3.53,2.95,66.37,66.37,0,0,1,1.4,18.56c.16,2.16-2.12,3.93-4.71,3.93h-5a1,1,0,0,1-1.09-.91V112.67a1,1,0,0,1,1.09-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M344.05,114.49l0,.22a63.32,63.32,0,0,1,1.43,10.36c-1.32,2.31-1.12,6.6-1.43,8.12-.37,1.74-.87.57-.77-2.07s-.91-14.52-1.09-16.94c-.11-1.51,1-.59,1.83.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M344.31,129.26v-7.82a.93.93,0,0,1,.22-.65.75.75,0,0,1,.57-.21v-.17a.93.93,0,0,0-.73.28,1.06,1.06,0,0,0-.26.75v7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M334.06,134.4h5.75s1.7-.45,1.7-1.42V130.8s-.25-.7-1.6-1.15-2.6-.66-2.82-1.36a3,3,0,0,1-.21-.95l-2.69.06-.13,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M334.18,128.11l-.11,5.42c1-.07,2.49-.17,3.3-.21,1.28-.06,2.69-.73,2.58-1.9s-2.55-1.86-3.87-2.67a4.44,4.44,0,0,0-1.9-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M336.88,133.67h2.52s1.52-.11,1.48-1-.1-1.49-.1-1.49a2.63,2.63,0,0,0-1.41-1.15,5.62,5.62,0,0,0-1.75-.51s-.77,1.1-.74,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M336.88,133.67h2.52a3.29,3.29,0,0,0,.69-.15c-.4-.35-1-1-.77-1.68a6,6,0,0,1,.88-1.34,3.87,3.87,0,0,0-.83-.48,6.53,6.53,0,0,0-.7-.27,3,3,0,0,1-.35,2.18,1.83,1.83,0,0,1-1.42.83c0,.28,0,.58,0,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M340.74,133.11a.62.62,0,0,0,.14-.45c0-.9-.1-1.49-.1-1.49a1.59,1.59,0,0,0-.27-.38,3,3,0,0,0-.15,1c0,.68.17,1.23.38,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M340,131.42c-.36,0-.65.15-.65.33s.29.32.65.32.64-.14.64-.32S340.3,131.42,340,131.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M338.8,132.24c-.55,0-1,.23-1,.53s.46.53,1,.53,1-.24,1-.53S339.36,132.24,338.8,132.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M339.44,130.45c-.28,0-.51.16-.51.35s.23.36.51.36.51-.16.51-.36S339.73,130.45,339.44,130.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M337.57,130.09c-.15,0-.27.27-.27.59s.12.6.27.6.28-.27.28-.6S337.72,130.09,337.57,130.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M337.51,132.64c-.13,0-.25.23-.25.51s.12.52.25.52.25-.23.25-.52S337.65,132.64,337.51,132.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M336.83,128.75c.27.23.61.31.76.19s.06-.41-.21-.64-.61-.31-.76-.18S336.57,128.53,336.83,128.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M338.45,123.4c.38-5.44,1.16-9.83,1.74-9.8s.74,4.47.36,9.91c-.14,2-.34,3.85-.56,5.4a18.67,18.67,0,0,0-1.75-.73c0-1.42.09-3.05.21-4.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M374.09,174.65a20.43,20.43,0,0,0-7-4.59c-9.38-3.72-24.86-2.68-29.69-1.63s-15,7-18.08,15.4c-2.82,7.77-3.8,11-3.81,23.51h3.86l.38-.38c0-10.94.87-13.8,3.34-20.61,2.67-7.37,11.61-12.59,15.85-13.5s17.8-1.82,26,1.44c.29.11.57.23.85.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M374.09,175.44a20.41,20.41,0,0,0-7-4.58c-9.38-3.72-24.86-2.68-29.69-1.64s-15,7-18.08,15.41c-2.82,7.77-3.8,11-3.81,23.51h0c0-11.9,1-15.18,3.81-22.8,3.05-8.41,13.24-14.36,18.08-15.4s20.31-2.08,29.69,1.64a20.69,20.69,0,0,1,6.29,3.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rear_wheel",
    "data-name": "rear wheel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M95.29,177.72a25.54,25.54,0,1,1-25.53,25.53,25.54,25.54,0,0,1,25.53-25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M95.29,177.93A25.33,25.33,0,1,1,70,203.25a25.32,25.32,0,0,1,25.32-25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M95.29,183.1a20.16,20.16,0,1,1-20.15,20.15A20.16,20.16,0,0,1,95.29,183.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M111,188a22,22,0,0,1-36.33,22.33,22.28,22.28,0,0,1-1-6.57A22,22,0,0,1,111,188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M95.29,180.85a22.4,22.4,0,0,1,22.4,22.4v.14a22.13,22.13,0,1,0-22.27,22.26h-.13a22.4,22.4,0,1,1,0-44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M95.29,182.13a21.13,21.13,0,0,1,21.13,21.12v.13a20.88,20.88,0,1,0-21,21h-.13a21.13,21.13,0,1,1,0-42.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M106.83,191.72a16.32,16.32,0,1,1-23.08,0A16.31,16.31,0,0,1,106.83,191.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M106.83,191.72l-.6-.58a16.09,16.09,0,1,0-7.66,28.1,16.32,16.32,0,0,0,8.26-27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M105.83,192.71a14.91,14.91,0,1,0,0,21.08,14.91,14.91,0,0,0,0-21.08Zm-.07.35a14.52,14.52,0,1,0,0,20.53,14.52,14.52,0,0,0,0-20.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M104.67,193.87a13.27,13.27,0,1,1-18.76,0A13.27,13.27,0,0,1,104.67,193.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M104.67,193.87a13.27,13.27,0,0,0-22.43,7,41.78,41.78,0,0,0,13.35,2,42.48,42.48,0,0,0,12.79-1.82,13.24,13.24,0,0,0-3.71-7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M104.67,193.87a13.25,13.25,0,0,0-21,3,13.29,13.29,0,0,0,23.23,0,13.25,13.25,0,0,0-2.24-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M101.6,196.78a9,9,0,1,1-12.71,0A9,9,0,0,1,101.6,196.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-142",
    cx: 95.59,
    cy: 203.46,
    r: 8.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M104.88,193.67a13.56,13.56,0,1,0,0,19.17,13.54,13.54,0,0,0,0-19.17Zm-.53.52a12.81,12.81,0,1,0,0,18.12,12.82,12.82,0,0,0,0-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M91.62,213a9.3,9.3,0,0,1-3.11-1.8.84.84,0,0,0-1.23.15h0c-.21.35.13.75.48,1.13a6.11,6.11,0,0,0,3.12,1.81c.52.11,1,.2,1.23-.15h0a.85.85,0,0,0-.49-1.14ZM84.88,205a9.47,9.47,0,0,1,0-3.6.83.83,0,0,0-.74-1h0c-.4,0-.58.48-.74,1a6.13,6.13,0,0,0,0,3.6c.16.5.34,1,.74,1h0a.84.84,0,0,0,.74-1Zm3.63-9.88a9.52,9.52,0,0,1,3.11-1.8.83.83,0,0,0,.49-1.13h0c-.2-.36-.71-.27-1.23-.15a6,6,0,0,0-3.12,1.8c-.35.38-.69.78-.48,1.13h0a.83.83,0,0,0,1.23.15Zm10.36-1.8a9.6,9.6,0,0,1,3.12,1.8.83.83,0,0,0,1.23-.15h0c.2-.35-.13-.75-.49-1.13a6,6,0,0,0-3.12-1.8c-.51-.12-1-.21-1.23.15h0a.84.84,0,0,0,.49,1.13Zm6.74,8.08a9.47,9.47,0,0,1,0,3.6.85.85,0,0,0,.74,1h0c.41,0,.59-.49.74-1a6,6,0,0,0,0-3.6c-.15-.51-.33-1-.74-1h0a.84.84,0,0,0-.74,1ZM102,211.24a9.32,9.32,0,0,1-3.12,1.8.85.85,0,0,0-.49,1.14h0c.21.35.72.26,1.23.15a6.11,6.11,0,0,0,3.12-1.81c.36-.38.69-.78.49-1.13h0a.85.85,0,0,0-1.23-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M101.43,197.12a8.68,8.68,0,1,1-12.27,0A8.67,8.67,0,0,1,101.43,197.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.53,200a4.57,4.57,0,1,0,0,6.47,4.57,4.57,0,0,0,0-6.47Zm-.63.62a3.69,3.69,0,1,0,0,5.22,3.69,3.69,0,0,0,0-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M95.45,195.08a1.82,1.82,0,1,1-1.82,1.81A1.82,1.82,0,0,1,95.45,195.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M95.22,194.86a1.84,1.84,0,1,1-1.84,1.84A1.85,1.85,0,0,1,95.22,194.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "94.88 195.09 95.66 195.35 96.45 195.6 96.61 196.41 96.78 197.22 96.17 197.77 95.55 198.31 94.77 198.06 93.99 197.8 93.82 196.99 93.65 196.19 94.27 195.64 94.88 195.09 94.88 195.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "94.91 195.25 95.62 195.48 96.33 195.71 96.48 196.44 96.63 197.17 96.07 197.66 95.52 198.16 94.81 197.93 94.11 197.69 93.96 196.97 93.81 196.24 94.36 195.74 94.91 195.25 94.91 195.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M95.41,196.15a.83.83,0,1,1-.83.83A.83.83,0,0,1,95.41,196.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M95.16,195.84a.83.83,0,1,1,0,1.66.83.83,0,0,1,0-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M95.19,195.92a.79.79,0,0,1,.79.8.79.79,0,0,1-1.58,0A.79.79,0,0,1,95.19,195.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M102.8,199.32a1.82,1.82,0,1,1-2.48-.66A1.82,1.82,0,0,1,102.8,199.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M102.43,199a1.84,1.84,0,1,1-2.51-.67A1.83,1.83,0,0,1,102.43,199Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "102.07 198.79 102.24 199.6 102.41 200.4 101.79 200.95 101.18 201.5 100.39 201.24 99.61 200.99 99.45 200.18 99.28 199.37 99.89 198.82 100.5 198.28 101.28 198.53 102.07 198.79 102.07 198.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "101.95 198.9 102.1 199.63 102.25 200.35 101.7 200.85 101.15 201.34 100.44 201.11 99.73 200.88 99.58 200.15 99.43 199.42 99.98 198.93 100.54 198.43 101.24 198.66 101.95 198.9 101.95 198.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M101.84,199.7a.83.83,0,0,1-.3,1.13.83.83,0,1,1,.3-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M101.56,199.41a.84.84,0,0,1-.31,1.14.83.83,0,1,1,.31-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M101.5,199.47a.8.8,0,0,1-.29,1.09.79.79,0,0,1-1.08-.29.8.8,0,0,1,.29-1.09A.79.79,0,0,1,101.5,199.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M102.83,207.5a1.81,1.81,0,1,1-.66-2.49A1.8,1.8,0,0,1,102.83,207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M102.48,207.27a1.84,1.84,0,1,1-.67-2.51A1.83,1.83,0,0,1,102.48,207.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "102.46 206.87 101.84 207.42 101.23 207.97 100.44 207.71 99.67 207.45 99.5 206.64 99.33 205.84 99.94 205.29 100.56 204.74 101.34 205 102.12 205.25 102.29 206.06 102.46 206.87 102.46 206.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "102.31 206.82 101.75 207.31 101.2 207.81 100.49 207.57 99.78 207.34 99.63 206.61 99.48 205.89 100.04 205.39 100.59 204.9 101.3 205.13 102 205.36 102.16 206.09 102.31 206.82 102.31 206.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M101.8,207a.82.82,0,1,1-.3-1.13A.82.82,0,0,1,101.8,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M101.66,206.73a.82.82,0,1,1-.3-1.13A.82.82,0,0,1,101.66,206.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M101.58,206.72a.79.79,0,0,1-1.08.29.8.8,0,0,1-.29-1.09.79.79,0,0,1,1.08-.29A.8.8,0,0,1,101.58,206.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M95.57,211.6a1.82,1.82,0,1,1,1.81-1.82A1.81,1.81,0,0,1,95.57,211.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M95.32,211.47a1.84,1.84,0,1,1,1.84-1.84A1.85,1.85,0,0,1,95.32,211.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "95.66 211.24 94.88 210.98 94.09 210.73 93.93 209.92 93.76 209.11 94.37 208.56 94.98 208.02 95.77 208.27 96.55 208.53 96.72 209.34 96.89 210.14 96.27 210.69 95.66 211.24 95.66 211.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "95.63 211.09 94.92 210.85 94.21 210.62 94.06 209.89 93.91 209.16 94.47 208.67 95.02 208.17 95.73 208.41 96.43 208.64 96.58 209.37 96.73 210.09 96.18 210.59 95.63 211.09 95.63 211.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M95.53,210.77a.83.83,0,1,1,.83-.83A.83.83,0,0,1,95.53,210.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M95.38,210.49a.83.83,0,1,1,0-1.66.83.83,0,0,1,0,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M95.35,210.41a.8.8,0,1,1,0-1.59.8.8,0,0,1,0,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M88.35,207.62a1.81,1.81,0,1,1,2.48.66A1.81,1.81,0,0,1,88.35,207.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M88.11,207.36a1.84,1.84,0,1,1,2.51.67A1.83,1.83,0,0,1,88.11,207.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "88.47 207.54 88.3 206.73 88.13 205.93 88.75 205.38 89.36 204.83 90.14 205.09 90.93 205.34 91.09 206.15 91.26 206.96 90.65 207.51 90.03 208.06 89.25 207.8 88.47 207.54 88.47 207.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "88.59 207.43 88.44 206.71 88.29 205.98 88.84 205.48 89.39 204.99 90.1 205.22 90.81 205.45 90.96 206.18 91.11 206.91 90.56 207.4 90 207.9 89.3 207.67 88.59 207.43 88.59 207.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M89.15,207.23a.81.81,0,0,1,.3-1.13.82.82,0,1,1-.3,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M89,206.92a.83.83,0,1,1,1.44-.83.83.83,0,0,1-1.44.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M89,206.86a.8.8,0,0,1,.29-1.09.79.79,0,0,1,1.08.29.8.8,0,0,1-.29,1.09A.79.79,0,0,1,89,206.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M88.32,199.42a1.82,1.82,0,0,1,3.15,1.82,1.82,1.82,0,0,1-3.15-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M88.05,199.06a1.84,1.84,0,1,1,.68,2.51A1.84,1.84,0,0,1,88.05,199.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "88.08 199.46 88.69 198.91 89.31 198.37 90.09 198.62 90.87 198.88 91.04 199.69 91.21 200.5 90.6 201.04 89.98 201.59 89.2 201.34 88.42 201.08 88.25 200.27 88.08 199.46 88.08 199.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "88.23 199.51 88.79 199.02 89.34 198.52 90.05 198.76 90.75 198.99 90.91 199.72 91.06 200.44 90.5 200.94 89.95 201.44 89.24 201.2 88.54 200.97 88.38 200.24 88.23 199.51 88.23 199.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M89.18,199.92a.82.82,0,0,1,1.13-.31.83.83,0,1,1-1.13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M88.88,199.6a.82.82,0,1,1,.3,1.13A.82.82,0,0,1,88.88,199.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M89,199.61a.79.79,0,0,1,1.08-.29.8.8,0,0,1,.29,1.09.79.79,0,0,1-1.08.29A.8.8,0,0,1,89,199.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M102.35,206.22a4.26,4.26,0,0,1-4.26,4.26c-2.44,0-7-4.54-7-7a4.25,4.25,0,0,1,4.26-4.25c2.43,0,7,4.53,7,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M95.24,198.93A4.26,4.26,0,1,1,91,203.19a4.26,4.26,0,0,1,4.25-4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M95.34,199a4.26,4.26,0,1,1-4.26,4.25A4.25,4.25,0,0,1,95.34,199Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "95.34 199.51 95.81 199.53 96.06 199.74 96.14 200.11 96.21 200.48 95.93 200.73 95.65 200.98 95.29 200.86 94.94 200.74 94.71 200.53 94.79 200.01 95.07 199.76 95.34 199.51 95.34 199.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "95.11 199.3 95.46 199.42 95.82 199.53 95.9 199.9 95.97 200.27 95.7 200.52 95.42 200.77 95.06 200.65 94.7 200.53 94.63 200.17 94.55 199.8 94.83 199.55 95.11 199.3 95.11 199.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M95.36,199.75a.42.42,0,1,1-.42.42A.42.42,0,0,1,95.36,199.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M95.24,199.6a.42.42,0,0,1,0,.84.42.42,0,1,1,0-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M95.25,199.64a.4.4,0,1,1-.4.4A.4.4,0,0,1,95.25,199.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M95.34,201.16a2.13,2.13,0,1,1-2.13,2.12,2.13,2.13,0,0,1,2.13-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M95.34,201.16a2.13,2.13,0,0,1,1.64.77,2.58,2.58,0,0,1-2.58,2.53,2.66,2.66,0,0,1-.94-.17,2.13,2.13,0,0,1,1.88-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M95.34,201.69a1.6,1.6,0,1,1-1.59,1.59,1.59,1.59,0,0,1,1.59-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M95.38,204.61a1.31,1.31,0,0,1-1-.53,1.55,1.55,0,0,0,.37,0,1.1,1.1,0,0,0,.26,0,.88.88,0,0,0,.42.11.9.9,0,0,0,.9-.89,1,1,0,0,0-.07-.35,1.75,1.75,0,0,0,0-.4,1.77,1.77,0,0,0,0-.23,1.3,1.3,0,0,1-.86,2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M95.34,202a1.31,1.31,0,0,1,1,.53,1.58,1.58,0,0,0-.38-.05,1.07,1.07,0,0,0-.25,0,.88.88,0,0,0-.42-.11.89.89,0,0,0-.9.89.82.82,0,0,0,.08.35,1.31,1.31,0,0,0,0,.39,1.93,1.93,0,0,0,0,.24,1.3,1.3,0,0,1,.86-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M95.38,203.17a.15.15,0,0,1,.15.15.15.15,0,0,1-.15.14.14.14,0,0,1-.15-.14.14.14,0,0,1,.15-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M95.34,203.13a.15.15,0,0,1,.15.15.15.15,0,0,1-.3,0,.15.15,0,0,1,.15-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M97.11,201.54a2.49,2.49,0,1,1-3.77,3.23,2.49,2.49,0,0,0,3.77-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M93.53,205a2.46,2.46,0,0,1-.72-1.75,2.49,2.49,0,0,1,4.49-1.48A2.49,2.49,0,0,0,93,203.55a2.46,2.46,0,0,0,.49,1.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "97.82 200.39 98.29 200.41 98.53 200.62 98.61 200.99 98.69 201.35 98.41 201.6 98.13 201.85 97.77 201.74 97.41 201.62 97.18 201.41 97.26 200.88 97.54 200.64 97.82 200.39 97.82 200.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "97.58 200.18 97.94 200.29 98.3 200.41 98.37 200.78 98.45 201.15 98.17 201.4 97.89 201.65 97.53 201.53 97.18 201.41 97.1 201.04 97.02 200.68 97.3 200.43 97.58 200.18 97.58 200.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M97.83,200.63a.42.42,0,1,1-.41.42A.42.42,0,0,1,97.83,200.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M97.71,200.48a.42.42,0,0,1,.42.42.41.41,0,0,1-.42.41.41.41,0,0,1-.41-.41A.41.41,0,0,1,97.71,200.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M97.72,200.52a.4.4,0,1,1-.4.4A.4.4,0,0,1,97.72,200.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "98.7 202.66 99.17 202.69 99.41 202.9 99.49 203.26 99.56 203.63 99.28 203.88 99 204.13 98.65 204.01 98.29 203.9 98.06 203.68 98.14 203.16 98.42 202.91 98.7 202.66 98.7 202.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "98.46 202.45 98.82 202.57 99.17 202.69 99.25 203.06 99.33 203.42 99.05 203.67 98.77 203.92 98.41 203.8 98.05 203.69 97.98 203.32 97.9 202.95 98.18 202.7 98.46 202.45 98.46 202.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M98.71,202.91a.42.42,0,0,1,.42.42.42.42,0,0,1-.84,0A.42.42,0,0,1,98.71,202.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M98.59,202.75a.42.42,0,1,1-.42.42A.42.42,0,0,1,98.59,202.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M98.6,202.79a.4.4,0,0,1,.4.4.4.4,0,1,1-.8,0A.4.4,0,0,1,98.6,202.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "97.73 205.06 98.2 205.09 98.44 205.3 98.52 205.66 98.59 206.03 98.32 206.28 98.03 206.53 97.68 206.41 97.32 206.29 97.09 206.08 97.17 205.56 97.45 205.31 97.73 205.06 97.73 205.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "97.49 204.85 97.85 204.97 98.21 205.09 98.28 205.45 98.36 205.82 98.08 206.07 97.8 206.32 97.44 206.2 97.08 206.09 97.01 205.72 96.93 205.35 97.21 205.1 97.49 204.85 97.49 204.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M97.74,205.31a.42.42,0,1,1,0,.83.42.42,0,0,1,0-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M97.62,205.15a.42.42,0,1,1-.42.42A.42.42,0,0,1,97.62,205.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M97.63,205.19a.4.4,0,1,1-.4.4A.4.4,0,0,1,97.63,205.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "95.47 206.11 95.94 206.13 96.18 206.34 96.26 206.71 96.34 207.07 96.06 207.32 95.78 207.57 95.42 207.46 95.07 207.34 94.84 207.13 94.91 206.6 95.19 206.35 95.47 206.11 95.47 206.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "95.24 205.9 95.59 206.01 95.95 206.13 96.02 206.5 96.1 206.87 95.82 207.12 95.54 207.36 95.19 207.25 94.83 207.13 94.75 206.76 94.67 206.4 94.96 206.15 95.24 205.9 95.24 205.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M95.49,206.35a.42.42,0,1,1-.42.42A.42.42,0,0,1,95.49,206.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M95.36,206.2a.42.42,0,1,1-.42.42A.42.42,0,0,1,95.36,206.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M95.38,206.24a.4.4,0,1,1,0,.8.4.4,0,1,1,0-.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "92.98 205.06 93.45 205.09 93.69 205.3 93.77 205.66 93.84 206.03 93.57 206.28 93.28 206.53 92.93 206.41 92.57 206.29 92.34 206.08 92.42 205.56 92.7 205.31 92.98 205.06 92.98 205.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "92.74 204.85 93.1 204.97 93.46 205.09 93.53 205.45 93.61 205.82 93.33 206.07 93.05 206.32 92.69 206.2 92.33 206.09 92.26 205.72 92.18 205.35 92.47 205.1 92.74 204.85 92.74 204.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M93,205.31a.42.42,0,1,1,0,.83.42.42,0,0,1,0-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M92.87,205.15a.42.42,0,1,1-.42.42A.42.42,0,0,1,92.87,205.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M92.88,205.19a.4.4,0,1,1-.4.4A.4.4,0,0,1,92.88,205.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "92 202.84 92.46 202.87 92.71 203.07 92.78 203.44 92.86 203.81 92.58 204.06 92.3 204.31 91.94 204.19 91.59 204.07 91.36 203.86 91.44 203.34 91.72 203.09 92 202.84 92 202.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "91.76 202.63 92.11 202.75 92.47 202.87 92.55 203.23 92.62 203.6 92.34 203.85 92.06 204.1 91.71 203.98 91.35 203.86 91.27 203.5 91.2 203.13 91.48 202.88 91.76 202.63 91.76 202.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M92,203.09a.41.41,0,0,1,.42.41.42.42,0,0,1-.84,0A.41.41,0,0,1,92,203.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M91.88,202.93a.42.42,0,1,1-.41.42A.42.42,0,0,1,91.88,202.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M91.89,203a.4.4,0,1,1,0,.8.4.4,0,0,1,0-.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "92.78 200.39 93.25 200.41 93.49 200.62 93.57 200.99 93.64 201.35 93.37 201.6 93.09 201.85 92.73 201.74 92.38 201.62 92.14 201.41 92.22 200.88 92.5 200.64 92.78 200.39 92.78 200.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "92.55 200.18 92.9 200.29 93.26 200.41 93.34 200.78 93.41 201.15 93.13 201.4 92.85 201.65 92.5 201.53 92.14 201.41 92.06 201.04 91.99 200.68 92.26 200.43 92.55 200.18 92.55 200.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M92.79,200.63a.42.42,0,0,1,0,.84.42.42,0,0,1,0-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M92.67,200.48a.42.42,0,0,1,.42.42.42.42,0,0,1-.84,0A.42.42,0,0,1,92.67,200.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M92.68,200.52a.4.4,0,1,1-.4.4A.4.4,0,0,1,92.68,200.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "front_wheel",
    "data-name": "front wheel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M350.46,175.75a25.54,25.54,0,1,1-25.54,25.53,25.54,25.54,0,0,1,25.54-25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M350.46,176a25.33,25.33,0,1,1-25.32,25.32A25.32,25.32,0,0,1,350.46,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M350.46,181.13a20.16,20.16,0,1,1-20.15,20.15,20.16,20.16,0,0,1,20.15-20.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M366.15,186a22,22,0,0,1-36.33,22.32A22,22,0,0,1,366.15,186Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M350.46,178.89a22.39,22.39,0,0,1,22.4,22.39v.14a22.14,22.14,0,1,0-22.27,22.26h-.13a22.4,22.4,0,1,1,0-44.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M350.46,180.16a21.13,21.13,0,0,1,21.13,21.12v.13a20.88,20.88,0,1,0-21,21h-.13a21.13,21.13,0,1,1,0-42.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M362,189.79a16.25,16.25,0,1,1-23,0A16.26,16.26,0,0,1,362,189.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M362,189.79l-.6-.57a16.25,16.25,0,1,0,.6,23.55,16.26,16.26,0,0,0,0-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M361,190.79a14.85,14.85,0,1,0,0,21,14.85,14.85,0,0,0,0-21Zm-.07.34a14.46,14.46,0,1,0,0,20.45,14.46,14.46,0,0,0,0-20.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M359.8,191.94a13.21,13.21,0,1,1-18.68,0A13.22,13.22,0,0,1,359.8,191.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M359.8,191.94a13.24,13.24,0,0,0-20.91,2.95,13.24,13.24,0,0,0,23.14,0,13.32,13.32,0,0,0-2.23-2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M360,191.74a13.5,13.5,0,1,0,0,19.09,13.5,13.5,0,0,0,0-19.09Zm-.53.52a12.76,12.76,0,1,0,0,18.05,12.76,12.76,0,0,0,0-18.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 350.46,
    cy: 201.28,
    r: 9.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M346.81,211a9.45,9.45,0,0,1-3.11-1.79.83.83,0,0,0-1.22.15h0c-.2.35.13.75.48,1.13a6.05,6.05,0,0,0,3.11,1.79c.51.12,1,.21,1.22-.14h0a.85.85,0,0,0-.48-1.14Zm-6.72-8a9.79,9.79,0,0,1,0-3.58.83.83,0,0,0-.73-1h0c-.41,0-.59.48-.74,1a5.91,5.91,0,0,0,0,3.58c.15.5.33,1,.74,1h0a.83.83,0,0,0,.73-1Zm3.61-9.83a9.52,9.52,0,0,1,3.11-1.8.83.83,0,0,0,.48-1.13h0c-.2-.35-.71-.26-1.22-.14a6,6,0,0,0-3.11,1.79c-.35.38-.68.78-.48,1.13h0a.84.84,0,0,0,1.22.15Zm10.32-1.8a9.55,9.55,0,0,1,3.11,1.8.83.83,0,0,0,1.22-.15h0c.2-.35-.12-.75-.48-1.13a6,6,0,0,0-3.11-1.79c-.51-.12-1-.21-1.22.14h0a.84.84,0,0,0,.48,1.13Zm6.72,8a9.37,9.37,0,0,1,0,3.58.83.83,0,0,0,.74,1h0c.4,0,.58-.49.73-1a5.91,5.91,0,0,0,0-3.58c-.15-.51-.33-1-.73-1h0a.84.84,0,0,0-.74,1Zm-3.61,9.83A9.32,9.32,0,0,1,354,211a.85.85,0,0,0-.48,1.14h0c.2.35.71.26,1.22.14a6.05,6.05,0,0,0,3.11-1.79c.36-.38.68-.78.48-1.13h0a.84.84,0,0,0-1.22-.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-167",
    cx: 350.07,
    cy: 200.9,
    r: 8.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M352.34,199.4a2.66,2.66,0,1,0,0,3.77,2.66,2.66,0,0,0,0-3.77Zm-.36.36a2.15,2.15,0,1,0,0,3,2.15,2.15,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M353.81,194.67c1.31.78,2.81,0,3.53-.39h0l.29.3-.29-.3c.05,0,.2.06.34.21a7.65,7.65,0,0,1,1.56,2,8.35,8.35,0,0,1,.82,2.08l-.3-.25.31.25s0,.05,0,.06l-.19.12a3.16,3.16,0,0,0-1.86,2.73,3,3,0,0,0,1.69,2.47h0a1.33,1.33,0,0,1,.42.43.16.16,0,0,1,0,.12,6.74,6.74,0,0,1-.79,2,8.59,8.59,0,0,1-1.34,1.69l-.3-.29.3.29s-.07,0-.13,0l-.19-.1a3.07,3.07,0,0,0-3.22-.22c-1.42.79-1.48,2.5-1.51,3.32v0h0s0,0,0,0a6.83,6.83,0,0,1-2.13.31,8.07,8.07,0,0,1-2.16-.32l-.24-.3.24.3a1.24,1.24,0,0,1-.43-.35.48.48,0,0,1-.12-.22v-.23c-.06-.94-.12-1.94-1-2.47-1.3-.79-2.81,0-3.53.39h0l-.29-.3.29.3c-.05,0-.2-.06-.34-.21a7.87,7.87,0,0,1-1.56-2,8.5,8.5,0,0,1-.82-2.08l.3.25-.3-.25s0-.05,0-.06l.19-.12a3.17,3.17,0,0,0,1.86-2.73,2.94,2.94,0,0,0-1.68-2.47h0a1.56,1.56,0,0,1-.42-.43q0-.09,0-.12a6.74,6.74,0,0,1,.79-2,8.64,8.64,0,0,1,1.34-1.7l.3.3-.3-.3s.07,0,.13,0l.19.1a3.1,3.1,0,0,0,3.22.22c1.42-.79,1.49-2.5,1.52-3.32v0h0s0,0,0,0a6.83,6.83,0,0,1,2.13-.31,8.07,8.07,0,0,1,2.16.32l.25.3-.25-.3a1.16,1.16,0,0,1,.43.35.48.48,0,0,1,.12.22v.23c.06.94.12,1.94,1,2.47Zm4.05.25a3.74,3.74,0,0,1-3.74.27,3.6,3.6,0,0,1-1.9-3.32,8.5,8.5,0,0,0-1.58-.18,6.58,6.58,0,0,0-2.09.31c0,.83-.1,2.57-1.55,3.37a3.28,3.28,0,0,1-3.41-.26l-.14-.07a8.62,8.62,0,0,0-1.31,1.66,6.81,6.81,0,0,0-.73,1.78,4,4,0,0,1,2.1,3.22,3.21,3.21,0,0,1-1.88,2.78l-.18.11a8.1,8.1,0,0,0,.75,1.89,5.88,5.88,0,0,0,.86,1.17,3.69,3.69,0,0,1,3.74-.27,3.6,3.6,0,0,1,1.9,3.32,8.5,8.5,0,0,0,1.58.18,6.88,6.88,0,0,0,2.09-.31c0-.84.1-2.57,1.55-3.37a3.24,3.24,0,0,1,3.41.26l.14.06a8.27,8.27,0,0,0,1.31-1.65,6.81,6.81,0,0,0,.73-1.78,4,4,0,0,1-2.1-3.22,3.21,3.21,0,0,1,1.88-2.78l.18-.12a7.77,7.77,0,0,0-.75-1.88,5.61,5.61,0,0,0-.86-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M352.57,195.44a2.36,2.36,0,0,0-2.22-2.71,2.26,2.26,0,0,0-2.1,2.73c.29,1.49,1.22,2.68,2.1,2.68s2-1.21,2.22-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M350.62,193.14a1.81,1.81,0,1,1-1.81,1.81A1.81,1.81,0,0,1,350.62,193.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M350.39,192.93a1.83,1.83,0,1,1-1.83,1.83A1.83,1.83,0,0,1,350.39,192.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "350.05 193.15 350.83 193.41 351.61 193.67 351.78 194.47 351.95 195.27 351.33 195.82 350.72 196.37 349.94 196.11 349.16 195.85 349 195.05 348.83 194.25 349.44 193.7 350.05 193.15 350.05 193.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "350.08 193.31 350.79 193.54 351.49 193.77 351.64 194.5 351.79 195.22 351.24 195.72 350.69 196.21 349.99 195.98 349.28 195.75 349.13 195.02 348.98 194.3 349.53 193.8 350.08 193.31 350.08 193.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M350.58,194.21a.83.83,0,1,1-.83.83A.83.83,0,0,1,350.58,194.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M350.33,193.91a.83.83,0,1,1-.82.82A.83.83,0,0,1,350.33,193.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M350.36,194a.79.79,0,1,1-.79.79A.79.79,0,0,1,350.36,194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M356.49,200.16a2.37,2.37,0,0,0,1.24-3.27,2.26,2.26,0,0,0-3.41-.46c-1.15,1-1.72,2.4-1.28,3.17s2,1.12,3.45.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M357.51,197.33a1.81,1.81,0,1,1-2.48-.67A1.82,1.82,0,0,1,357.51,197.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M357.57,197a1.83,1.83,0,1,1-2.5-.67A1.82,1.82,0,0,1,357.57,197Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "357.21 196.84 357.38 197.64 357.55 198.45 356.93 198.99 356.32 199.54 355.54 199.28 354.76 199.03 354.6 198.22 354.43 197.42 355.04 196.87 355.65 196.33 356.43 196.58 357.21 196.84 357.21 196.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "357.09 196.95 357.25 197.67 357.39 198.4 356.84 198.89 356.29 199.38 355.59 199.15 354.88 198.92 354.73 198.19 354.58 197.47 355.13 196.98 355.69 196.48 356.39 196.71 357.09 196.95 357.09 196.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M357,197.74a.83.83,0,1,1-1.13-.3A.83.83,0,0,1,357,197.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M356.7,197.46a.83.83,0,1,1-1.12-.3A.82.82,0,0,1,356.7,197.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M356.65,197.52a.81.81,0,0,1-.29,1.08.79.79,0,1,1,.29-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M354.36,205.92a2.37,2.37,0,0,0,3.46-.56,2.27,2.27,0,0,0-1.31-3.19c-1.45-.49-2.94-.28-3.38.48s.05,2.34,1.23,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M357.33,205.38a1.81,1.81,0,1,1-.67-2.47A1.81,1.81,0,0,1,357.33,205.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M357.62,205.29a1.83,1.83,0,1,1-3.16-1.83,1.83,1.83,0,1,1,3.16,1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "357.6 204.88 356.99 205.43 356.37 205.98 355.59 205.72 354.82 205.46 354.65 204.66 354.48 203.86 355.09 203.31 355.7 202.76 356.49 203.02 357.26 203.28 357.43 204.08 357.6 204.88 357.6 204.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "357.45 204.83 356.89 205.33 356.34 205.82 355.64 205.59 354.93 205.36 354.79 204.63 354.63 203.91 355.19 203.41 355.74 202.92 356.44 203.15 357.15 203.38 357.3 204.11 357.45 204.83 357.45 204.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M357,205a.82.82,0,0,1-1.13.3.81.81,0,0,1-.3-1.12.82.82,0,0,1,1.12-.31A.83.83,0,0,1,357,205Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M356.81,204.75a.82.82,0,0,1-1.13.3.82.82,0,0,1,.82-1.42A.82.82,0,0,1,356.81,204.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M356.73,204.74a.8.8,0,0,1-1.08.28.79.79,0,0,1-.29-1.08.79.79,0,1,1,1.37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M348.31,207a2.36,2.36,0,0,0,2.21,2.71,2.26,2.26,0,0,0,2.11-2.73c-.29-1.5-1.22-2.69-2.11-2.69s-2,1.21-2.21,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M350.26,209.25a1.81,1.81,0,1,1,1.81-1.81A1.81,1.81,0,0,1,350.26,209.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M350.49,209.46a1.83,1.83,0,1,1,1.83-1.83A1.82,1.82,0,0,1,350.49,209.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "350.83 209.24 350.05 208.99 349.27 208.73 349.1 207.92 348.93 207.12 349.54 206.57 350.16 206.03 350.94 206.28 351.71 206.54 351.88 207.34 352.05 208.15 351.44 208.69 350.83 209.24 350.83 209.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "350.79 209.09 350.09 208.85 349.39 208.62 349.24 207.9 349.08 207.17 349.63 206.68 350.19 206.18 350.89 206.42 351.6 206.65 351.75 207.37 351.9 208.1 351.35 208.59 350.79 209.09 350.79 209.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M350.7,208.77a.82.82,0,0,1-.83-.82.83.83,0,0,1,1.66,0A.82.82,0,0,1,350.7,208.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M350.54,208.49a.83.83,0,1,1,.83-.83A.83.83,0,0,1,350.54,208.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M350.52,208.41a.79.79,0,1,1,.79-.79A.79.79,0,0,1,350.52,208.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M344.38,202.24a2.35,2.35,0,0,0-1.23,3.27,2.27,2.27,0,0,0,3.41.46c1.15-1,1.72-2.41,1.27-3.17s-2-1.13-3.45-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M343.37,205.07a1.81,1.81,0,1,1,2.47.66A1.81,1.81,0,0,1,343.37,205.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M343.31,205.38a1.83,1.83,0,0,1,3.17-1.83,1.83,1.83,0,1,1-3.17,1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "343.67 205.55 343.5 204.75 343.33 203.95 343.94 203.4 344.56 202.85 345.33 203.11 346.11 203.37 346.28 204.17 346.45 204.97 345.84 205.52 345.23 206.07 344.44 205.81 343.67 205.55 343.67 205.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "343.78 205.45 343.63 204.72 343.48 204 344.04 203.5 344.59 203.01 345.29 203.24 345.99 203.47 346.14 204.2 346.3 204.93 345.74 205.42 345.19 205.91 344.49 205.68 343.78 205.45 343.78 205.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M344.34,205.24a.81.81,0,0,1,.3-1.12.82.82,0,0,1,1.13.3.82.82,0,1,1-1.43.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M344.17,204.93a.83.83,0,1,1,1.13.31A.83.83,0,0,1,344.17,204.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M344.23,204.87a.79.79,0,1,1,1.08.29A.79.79,0,0,1,344.23,204.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M346.51,196.47a2.37,2.37,0,0,0-3.45.56,2.27,2.27,0,0,0,1.31,3.19c1.44.5,2.94.29,3.38-.48s-.05-2.34-1.24-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M343.55,197a1.81,1.81,0,1,1,.66,2.47A1.82,1.82,0,0,1,343.55,197Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M343.25,197.11a1.83,1.83,0,1,1,.67,2.5A1.82,1.82,0,0,1,343.25,197.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "343.28 197.51 343.89 196.96 344.5 196.42 345.28 196.68 346.06 196.93 346.23 197.73 346.4 198.54 345.79 199.09 345.17 199.63 344.39 199.37 343.61 199.12 343.45 198.31 343.28 197.51 343.28 197.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "343.43 197.56 343.98 197.07 344.54 196.57 345.24 196.81 345.94 197.04 346.09 197.76 346.24 198.49 345.69 198.98 345.14 199.47 344.44 199.24 343.73 199.01 343.58 198.29 343.43 197.56 343.43 197.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M344.37,198a.83.83,0,0,1,1.13-.3.82.82,0,0,1-.82,1.43A.83.83,0,0,1,344.37,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M344.07,197.64a.83.83,0,1,1,.3,1.13A.83.83,0,0,1,344.07,197.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M344.15,197.66a.79.79,0,1,1,.29,1.08A.79.79,0,0,1,344.15,197.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock-2",
    "data-name": "lock"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M250.65,140.15h4.5c1,0,1.51.93,1.89,1.89a17.16,17.16,0,0,1,0,12.61c-.35,1-.85,1.89-1.89,1.89h-4.5c-1,0-1.55-.91-1.89-1.89a19.13,19.13,0,0,1,0-12.61c.32-1,.85-1.89,1.89-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M251.41,142.84h3c.69,0,1,.58,1.26,1.19a10.08,10.08,0,0,1,0,7.9c-.23.61-.57,1.18-1.26,1.18h-3c-.7,0-1-.56-1.27-1.18a11.25,11.25,0,0,1,0-7.9c.22-.62.57-1.19,1.27-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M251.15,145.6c-.11-.25-.24-.39-.37-.39-.4,0-.72,1.29-.72,2.87s.32,2.87.72,2.87c.13,0,.26-.14.37-.38a6.93,6.93,0,0,1-.37-2.49,6.83,6.83,0,0,1,.37-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M253.74,141.08H252a.51.51,0,0,0-.56.43v12a.51.51,0,0,0,.56.44h1.7a.52.52,0,0,0,.57-.44v-12c0-.24-.25-.43-.57-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M250.76,142.84h.51c-.7,0-1.05.57-1.27,1.19a11.31,11.31,0,0,0,0,7.9c.23.62.57,1.18,1.27,1.18h-.51c-.7,0-1-.56-1.27-1.18a11.31,11.31,0,0,1,0-7.9c.22-.62.57-1.19,1.27-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M253.51,141.4h-1.23a.42.42,0,0,0-.42.41v11.42a.41.41,0,0,0,.42.41h1.23a.41.41,0,0,0,.42-.41V141.81a.42.42,0,0,0-.42-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M253.75,146.06a18,18,0,0,0-.26-4.28,18.37,18.37,0,0,0-.25,4.28,18.44,18.44,0,0,0,.25,4.28,18.09,18.09,0,0,0,.26-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M253.66,154.74a.77.77,0,1,0-.76.76.76.76,0,0,0,.76-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M252.32,153.54a1.33,1.33,0,0,0,.58,2.52H253a1.56,1.56,0,0,1-1.14-1.34,1.3,1.3,0,0,1,.42-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M256.34,141.61a7.16,7.16,0,0,1,.42.88,15.21,15.21,0,0,1,.94,8,7.63,7.63,0,0,1-1.47,2.78,12.92,12.92,0,0,0-.07-10,2.75,2.75,0,0,0-1-1.35c.08-.22.39-.37,1.15-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "157.02 134.21 62.62 134.1 62.62 138.26 157.02 138.38 157.02 134.21 157.02 134.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "157.02 137.08 62.62 136.97 62.62 138.4 157.02 138.52 157.02 137.08 157.02 137.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "157.02 134.24 62.62 134.13 62.62 135.56 157.02 135.68 157.02 134.24 157.02 134.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M63.36,133.94a1.74,1.74,0,0,0-2,1.64v1.29a1.77,1.77,0,0,0,2,1.58v-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M156.8,133.94a1.74,1.74,0,0,1,2,1.64v1.29a1.77,1.77,0,0,1-2,1.58v-4.51Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-177",
    transform: "translate(67.42 118.55) scale(1.1 1)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-178",
    x: 5.39,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-179",
    x: 12.12,
    y: 0
  }, "\u015F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-180",
    x: 16.87,
    y: 0
  }, "\u0131ma"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M128.79,104.83v14.31h.06c.31,0,.61,0,.92,0s.25-.07.27-.26c.11-1,.23-1.93.35-2.9.22-1.88.43-3.76.69-5.63a16.65,16.65,0,0,1,.49-1.87c.65,0,1.29,0,1.93.1,1.25.09,2.5.17,3.74.31a8.08,8.08,0,0,1,4,1.35,8.27,8.27,0,0,1,2.48,3.26A41.29,41.29,0,0,1,146,120a.67.67,0,0,1,0,.37,1,1,0,0,0,.13,1,2.67,2.67,0,0,1,.16.31,8.11,8.11,0,0,1-.65.66.48.48,0,0,1-.3.13c-.47,0-.95,0-1.42,0a.3.3,0,0,0-.23.18,2.28,2.28,0,0,1-4.51,0,1.42,1.42,0,0,0-.05-.16h-9.48a3.09,3.09,0,0,1-.83,1.55v4.15h21.4V104.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M144.37,120.34H145l-.91-1.58c-.23-.4-.23-.4-.65-.17.26.55.51,1.09.78,1.63A.26.26,0,0,0,144.37,120.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.62,122.47h9.48a1.42,1.42,0,0,1,.05.16,2.28,2.28,0,0,0,4.51,0,.3.3,0,0,1,.23-.18c.47,0,1,0,1.42,0a.48.48,0,0,0,.3-.13,8.11,8.11,0,0,0,.65-.66,2.67,2.67,0,0,0-.16-.31,1,1,0,0,1-.13-1,.67.67,0,0,0,0-.37,41.29,41.29,0,0,0-2.23-6.51,8.27,8.27,0,0,0-2.48-3.26,8.08,8.08,0,0,0-4-1.35c-1.24-.14-2.49-.22-3.74-.31-.64,0-1.28-.07-1.93-.1a16.65,16.65,0,0,0-.49,1.87c-.26,1.87-.47,3.75-.69,5.63-.12,1-.24,1.93-.35,2.9,0,.19-.09.27-.27.26s-.61,0-.92,0h-.06l-.71,3C128.48,121.8,128.62,122.47,129.62,122.47Zm11.79.85a1.41,1.41,0,0,1,0-2.79,1.29,1.29,0,0,1,1.21,1.39A1.32,1.32,0,0,1,141.41,123.32Zm-.27-12.16a.36.36,0,0,1,.36,0,6.88,6.88,0,0,1,1.46,2c.39.78.72,1.59,1.08,2.39,0,.06,0,.12.07.23s-.11.19-.18.21a.29.29,0,0,1-.26-.11,3.35,3.35,0,0,1-.23-.55,10.87,10.87,0,0,0-2.25-3.79C141.07,111.45,141,111.28,141.14,111.16Zm-3.53-1.54c0-.1.14-.18.18-.24a7.48,7.48,0,0,1,2.46.85c.08,0,.1.24.15.36-.11,0-.25.15-.32.11a8.35,8.35,0,0,0-2.24-.76C137.68,109.9,137.56,109.82,137.61,109.62Zm-6.3,3.95.36-2.93c0-.11,0-.23.06-.38.82,0,1.62.09,2.41.16.07,0,.16.15.2.25.23.66.42,1.35.68,2a2.7,2.7,0,0,0,1.69,1.64c2.25.76,4.47,1.6,6.71,2.39a2.65,2.65,0,0,0,.89.1.28.28,0,0,1,.31.26c.28,1,.58,1.92.86,2.89a.68.68,0,0,1,0,.42c-.12.38-.19.89-.44,1.07s-.7.06-1.07.07h-.23a2.92,2.92,0,0,0-.85-1.66,2.2,2.2,0,0,0-3.65,1.18c-.08.25-.18.3-.4.29l-6.18-.26a.59.59,0,0,1-.33-.13c-.52-.43-1-.87-1.55-1.33a.5.5,0,0,1-.14-.39C130.84,117.32,131.08,115.45,131.31,113.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M132.31,120.92a.59.59,0,0,0,.33.13l6.18.26c.22,0,.32,0,.4-.29a2.2,2.2,0,0,1,3.65-1.18,2.92,2.92,0,0,1,.85,1.66H144c.37,0,.81.13,1.07-.07s.32-.69.44-1.07a.68.68,0,0,0,0-.42c-.28-1-.58-1.93-.86-2.89a.28.28,0,0,0-.31-.26,2.65,2.65,0,0,1-.89-.1c-2.24-.79-4.46-1.63-6.71-2.39a2.7,2.7,0,0,1-1.69-1.64c-.26-.65-.45-1.34-.68-2,0-.1-.13-.24-.2-.25-.79-.07-1.59-.11-2.41-.16,0,.15,0,.27-.06.38l-.36,2.93c-.23,1.88-.47,3.75-.69,5.63a.5.5,0,0,0,.14.39C131.27,120.05,131.79,120.49,132.31,120.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M141.4,120.53a1.41,1.41,0,1,0,1.21,1.39A1.29,1.29,0,0,0,141.4,120.53Zm0,2.33a.94.94,0,0,1,0-1.87.94.94,0,0,1,0,1.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M143.44,115.36a3.35,3.35,0,0,0,.23.55.29.29,0,0,0,.26.11c.07,0,.13-.14.18-.21s-.05-.17-.07-.23c-.36-.8-.69-1.61-1.08-2.39a6.88,6.88,0,0,0-1.46-2,.36.36,0,0,0-.36,0c-.14.12-.07.29.05.41A10.87,10.87,0,0,1,143.44,115.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M137.84,109.94a8.35,8.35,0,0,1,2.24.76c.07,0,.21-.07.32-.11-.05-.12-.07-.31-.15-.36a7.48,7.48,0,0,0-2.46-.85c0,.06-.16.14-.18.24S137.68,109.9,137.84,109.94Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4,121a.94.94,0,0,0,0,1.87.94.94,0,0,0,0-1.87Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 141.76,
    cy: 121.39,
    r: 3.17
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.72,118.81a2.49,2.49,0,1,0,2.49,2.49A2.49,2.49,0,0,0,141.72,118.81Zm0,3.61a1.13,1.13,0,0,1,0-2.25,1.13,1.13,0,1,1,0,2.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M145,117.39l1,1.7c-.26,0-.45,0-.64,0a.31.31,0,0,1-.19-.13c-.28-.57-.55-1.16-.83-1.74C144.72,117,144.72,117,145,117.39Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.84,118.52l-3.79.35h5v1.18l-7.88.59h7.88v1.13l-9.89.69H116l0,0h4.17l0,0h2.83a.66.66,0,0,0,.6.65h3a.65.65,0,0,0,.59-.65h3.4v-2.85h0v-1.09Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 117.9,
    cy: 122,
    r: 2.84
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 117.94,
    cy: 121.62,
    r: 2.89
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.91,119.28a2.26,2.26,0,1,0,2.26,2.26A2.27,2.27,0,0,0,117.91,119.28Zm0,3.28a1,1,0,1,1,1-1A1,1,0,0,1,117.91,122.56Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-183",
    transform: "translate(108.45 118.76) rotate(-5.51) scale(1.1 1)"
  }, "c\u0131m")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAraclar09);
export default __webpack_public_path__ + "static/media/araclar-09.6cca8ace6b97f1afe5519fd6cece89e7.svg";
export { ForwardRef as ReactComponent };